!function() {
  var e = {
    537: function(e, t, r) {
      "use strict";
      r.r(t);
      var n, i, s, o, a = !1, l = !1, c = [];
      function d(e) {
        !function(e) {
          c.includes(e) || c.push(e);
          l || a || (a = !0, queueMicrotask(h));
        }(e);
      }
      function u(e) {
        let t = c.indexOf(e);
        -1 !== t && c.splice(t, 1);
      }
      function h() {
        a = !1, l = !0;
        for (let e = 0; e < c.length; e++) c[e]();
        c.length = 0, l = !1;
      }
      var f = !0;
      function p(e) {
        i = e;
      }
      var m = [], g = [], _ = [];
      function v(e, t) {
        "function" == typeof t ? (e._x_cleanups || (e._x_cleanups = []), e._x_cleanups.push(t)) : (t = e, 
        g.push(t));
      }
      function y(e, t) {
        e._x_attributeCleanups && Object.entries(e._x_attributeCleanups).forEach((([r, n]) => {
          (void 0 === t || t.includes(r)) && (n.forEach((e => e())), delete e._x_attributeCleanups[r]);
        }));
      }
      var x = new MutationObserver(P), b = !1;
      function w() {
        x.observe(document, {
          subtree: !0,
          childList: !0,
          attributes: !0,
          attributeOldValue: !0
        }), b = !0;
      }
      function $() {
        (S = S.concat(x.takeRecords())).length && !E && (E = !0, queueMicrotask((() => {
          P(S), S.length = 0, E = !1;
        }))), x.disconnect(), b = !1;
      }
      var S = [], E = !1;
      function C(e) {
        if (!b) return e();
        $();
        let t = e();
        return w(), t;
      }
      var k = !1, O = [];
      function P(e) {
        if (k) return void (O = O.concat(e));
        let t = [], r = [], n = new Map, i = new Map;
        for (let s = 0; s < e.length; s++) if (!e[s].target._x_ignoreMutationObserver && ("childList" === e[s].type && (e[s].addedNodes.forEach((e => 1 === e.nodeType && t.push(e))), 
        e[s].removedNodes.forEach((e => 1 === e.nodeType && r.push(e)))), "attributes" === e[s].type)) {
          let t = e[s].target, r = e[s].attributeName, o = e[s].oldValue, a = () => {
            n.has(t) || n.set(t, []), n.get(t).push({
              name: r,
              value: t.getAttribute(r)
            });
          }, l = () => {
            i.has(t) || i.set(t, []), i.get(t).push(r);
          };
          t.hasAttribute(r) && null === o ? a() : t.hasAttribute(r) ? (l(), a()) : l();
        }
        i.forEach(((e, t) => {
          y(t, e);
        })), n.forEach(((e, t) => {
          m.forEach((r => r(t, e)));
        }));
        for (let e of r) if (!t.includes(e) && (g.forEach((t => t(e))), e._x_cleanups)) for (;e._x_cleanups.length; ) e._x_cleanups.pop()();
        t.forEach((e => {
          e._x_ignoreSelf = !0, e._x_ignore = !0;
        }));
        for (let e of t) r.includes(e) || e.isConnected && (delete e._x_ignoreSelf, delete e._x_ignore, 
        _.forEach((t => t(e))), e._x_ignore = !0, e._x_ignoreSelf = !0);
        t.forEach((e => {
          delete e._x_ignoreSelf, delete e._x_ignore;
        })), t = null, r = null, n = null, i = null;
      }
      function L(e) {
        return q(I(e));
      }
      function A(e, t, r) {
        return e._x_dataStack = [ t, ...I(r || e) ], () => {
          e._x_dataStack = e._x_dataStack.filter((e => e !== t));
        };
      }
      function T(e, t) {
        let r = e._x_dataStack[0];
        Object.entries(t).forEach((([e, t]) => {
          r[e] = t;
        }));
      }
      function I(e) {
        return e._x_dataStack ? e._x_dataStack : "function" == typeof ShadowRoot && e instanceof ShadowRoot ? I(e.host) : e.parentNode ? I(e.parentNode) : [];
      }
      function q(e) {
        let t = new Proxy({}, {
          ownKeys: () => Array.from(new Set(e.flatMap((e => Object.keys(e))))),
          has: (t, r) => e.some((e => e.hasOwnProperty(r))),
          get: (r, n) => (e.find((e => {
            if (e.hasOwnProperty(n)) {
              let r = Object.getOwnPropertyDescriptor(e, n);
              if (r.get && r.get._x_alreadyBound || r.set && r.set._x_alreadyBound) return !0;
              if ((r.get || r.set) && r.enumerable) {
                let i = r.get, s = r.set, o = r;
                i = i && i.bind(t), s = s && s.bind(t), i && (i._x_alreadyBound = !0), s && (s._x_alreadyBound = !0), 
                Object.defineProperty(e, n, {
                  ...o,
                  get: i,
                  set: s
                });
              }
              return !0;
            }
            return !1;
          })) || {})[n],
          set: (t, r, n) => {
            let i = e.find((e => e.hasOwnProperty(r)));
            return i ? i[r] = n : e[e.length - 1][r] = n, !0;
          }
        });
        return t;
      }
      function M(e) {
        let t = (r, n = "") => {
          Object.entries(Object.getOwnPropertyDescriptors(r)).forEach((([i, {value: s, enumerable: o}]) => {
            if (!1 === o || void 0 === s) return;
            let a = "" === n ? i : `${n}.${i}`;
            var l;
            "object" == typeof s && null !== s && s._x_interceptor ? r[i] = s.initialize(e, a, i) : "object" != typeof (l = s) || Array.isArray(l) || null === l || s === r || s instanceof Element || t(s, a);
          }));
        };
        return t(e);
      }
      function j(e, t = (() => {})) {
        let r = {
          initialValue: void 0,
          _x_interceptor: !0,
          initialize(t, r, n) {
            return e(this.initialValue, (() => function(e, t) {
              return t.split(".").reduce(((e, t) => e[t]), e);
            }(t, r)), (e => N(t, r, e)), r, n);
          }
        };
        return t(r), e => {
          if ("object" == typeof e && null !== e && e._x_interceptor) {
            let t = r.initialize.bind(r);
            r.initialize = (n, i, s) => {
              let o = e.initialize(n, i, s);
              return r.initialValue = o, t(n, i, s);
            };
          } else r.initialValue = e;
          return r;
        };
      }
      function N(e, t, r) {
        if ("string" == typeof t && (t = t.split(".")), 1 !== t.length) {
          if (0 === t.length) throw error;
          return e[t[0]] || (e[t[0]] = {}), N(e[t[0]], t.slice(1), r);
        }
        e[t[0]] = r;
      }
      var D = {};
      function R(e, t) {
        D[e] = t;
      }
      function B(e, t) {
        return Object.entries(D).forEach((([r, n]) => {
          Object.defineProperty(e, `$${r}`, {
            get() {
              let [e, r] = se(t);
              return e = {
                interceptor: j,
                ...e
              }, v(t, r), n(t, e);
            },
            enumerable: !1
          });
        })), e;
      }
      function H(e, t, r, ...n) {
        try {
          return r(...n);
        } catch (r) {
          F(r, e, t);
        }
      }
      function F(e, t, r) {
        Object.assign(e, {
          el: t,
          expression: r
        }), console.warn(`Alpine Expression Error: ${e.message}\n\n${r ? 'Expression: "' + r + '"\n\n' : ""}`, t), 
        setTimeout((() => {
          throw e;
        }), 0);
      }
      var z = !0;
      function V(e, t, r = {}) {
        let n;
        return W(e, t)((e => n = e), r), n;
      }
      function W(...e) {
        return U(...e);
      }
      var U = J;
      function J(e, t) {
        let r = {};
        B(r, e);
        let n = [ r, ...I(e) ];
        if ("function" == typeof t) return function(e, t) {
          return (r = (() => {}), {scope: n = {}, params: i = []} = {}) => {
            G(r, t.apply(q([ n, ...e ]), i));
          };
        }(n, t);
        let i = function(e, t, r) {
          let n = function(e, t) {
            if (K[e]) return K[e];
            let r = Object.getPrototypeOf((async function() {})).constructor, n = /^[\n\s]*if.*\(.*\)/.test(e) || /^(let|const)\s/.test(e) ? `(async()=>{ ${e} })()` : e;
            const i = () => {
              try {
                return new r([ "__self", "scope" ], `with (scope) { __self.result = ${n} }; __self.finished = true; return __self.result;`);
              } catch (r) {
                return F(r, t, e), Promise.resolve();
              }
            };
            let s = i();
            return K[e] = s, s;
          }(t, r);
          return (i = (() => {}), {scope: s = {}, params: o = []} = {}) => {
            n.result = void 0, n.finished = !1;
            let a = q([ s, ...e ]);
            if ("function" == typeof n) {
              let e = n(n, a).catch((e => F(e, r, t)));
              n.finished ? (G(i, n.result, a, o, r), n.result = void 0) : e.then((e => {
                G(i, e, a, o, r);
              })).catch((e => F(e, r, t))).finally((() => n.result = void 0));
            }
          };
        }(n, t, e);
        return H.bind(null, e, t, i);
      }
      var K = {};
      function G(e, t, r, n, i) {
        if (z && "function" == typeof t) {
          let s = t.apply(r, n);
          s instanceof Promise ? s.then((t => G(e, t, r, n))).catch((e => F(e, i, t))) : e(s);
        } else "object" == typeof t && t instanceof Promise ? t.then((t => e(t))) : e(t);
      }
      var Z = "x-";
      function Y(e = "") {
        return Z + e;
      }
      var Q = {};
      function X(e, t) {
        return Q[e] = t, {
          before(t) {
            if (!Q[t]) return void console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
            const r = fe.indexOf(t) ?? fe.indexOf("DEFAULT");
            r >= 0 && fe.splice(r, 0, e);
          }
        };
      }
      function ee(e, t, r) {
        if (t = Array.from(t), e._x_virtualDirectives) {
          let r = Object.entries(e._x_virtualDirectives).map((([e, t]) => ({
            name: e,
            value: t
          }))), n = te(r);
          r = r.map((e => n.find((t => t.name === e.name)) ? {
            name: `x-bind:${e.name}`,
            value: `"${e.value}"`
          } : e)), t = t.concat(r);
        }
        let n = {}, i = t.map(ae(((e, t) => n[e] = t))).filter(de).map(function(e, t) {
          return ({name: r, value: n}) => {
            let i = r.match(ue()), s = r.match(/:([a-zA-Z0-9\-:]+)/), o = r.match(/\.[^.\]]+(?=[^\]]*$)/g) || [], a = t || e[r] || r;
            return {
              type: i ? i[1] : null,
              value: s ? s[1] : null,
              modifiers: o.map((e => e.replace(".", ""))),
              expression: n,
              original: a
            };
          };
        }(n, r)).sort(pe);
        return i.map((t => function(e, t) {
          let r = () => {}, n = Q[t.type] || r, [i, s] = se(e);
          !function(e, t, r) {
            e._x_attributeCleanups || (e._x_attributeCleanups = {}), e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []), 
            e._x_attributeCleanups[t].push(r);
          }(e, t.original, s);
          let o = () => {
            e._x_ignore || e._x_ignoreSelf || (n.inline && n.inline(e, t, i), n = n.bind(n, e, t, i), 
            re ? ne.get(ie).push(n) : n());
          };
          return o.runCleanups = s, o;
        }(e, t)));
      }
      function te(e) {
        return Array.from(e).map(ae()).filter((e => !de(e)));
      }
      var re = !1, ne = new Map, ie = Symbol();
      function se(e) {
        let t = [], [r, n] = function(e) {
          let t = () => {};
          return [ r => {
            let n = i(r);
            return e._x_effects || (e._x_effects = new Set, e._x_runEffects = () => {
              e._x_effects.forEach((e => e()));
            }), e._x_effects.add(n), t = () => {
              void 0 !== n && (e._x_effects.delete(n), s(n));
            }, n;
          }, () => {
            t();
          } ];
        }(e);
        t.push(n);
        return [ {
          Alpine: Xe,
          effect: r,
          cleanup: e => t.push(e),
          evaluateLater: W.bind(W, e),
          evaluate: V.bind(V, e)
        }, () => t.forEach((e => e())) ];
      }
      var oe = (e, t) => ({name: r, value: n}) => (r.startsWith(e) && (r = r.replace(e, t)), 
      {
        name: r,
        value: n
      });
      function ae(e = (() => {})) {
        return ({name: t, value: r}) => {
          let {name: n, value: i} = le.reduce(((e, t) => t(e)), {
            name: t,
            value: r
          });
          return n !== t && e(n, t), {
            name: n,
            value: i
          };
        };
      }
      var le = [];
      function ce(e) {
        le.push(e);
      }
      function de({name: e}) {
        return ue().test(e);
      }
      var ue = () => new RegExp(`^${Z}([^:^.]+)\\b`);
      var he = "DEFAULT", fe = [ "ignore", "ref", "data", "id", "radio", "tabs", "switch", "disclosure", "menu", "listbox", "combobox", "bind", "init", "for", "mask", "model", "modelable", "transition", "show", "if", he, "teleport" ];
      function pe(e, t) {
        let r = -1 === fe.indexOf(e.type) ? he : e.type, n = -1 === fe.indexOf(t.type) ? he : t.type;
        return fe.indexOf(r) - fe.indexOf(n);
      }
      function me(e, t, r = {}) {
        e.dispatchEvent(new CustomEvent(t, {
          detail: r,
          bubbles: !0,
          composed: !0,
          cancelable: !0
        }));
      }
      function ge(e, t) {
        if ("function" == typeof ShadowRoot && e instanceof ShadowRoot) return void Array.from(e.children).forEach((e => ge(e, t)));
        let r = !1;
        if (t(e, (() => r = !0)), r) return;
        let n = e.firstElementChild;
        for (;n; ) ge(n, t), n = n.nextElementSibling;
      }
      function _e(e, ...t) {
        console.warn(`Alpine Warning: ${e}`, ...t);
      }
      var ve = [], ye = [];
      function xe() {
        return ve.map((e => e()));
      }
      function be() {
        return ve.concat(ye).map((e => e()));
      }
      function we(e) {
        ve.push(e);
      }
      function $e(e) {
        ye.push(e);
      }
      function Se(e, t = !1) {
        return Ee(e, (e => {
          if ((t ? be() : xe()).some((t => e.matches(t)))) return !0;
        }));
      }
      function Ee(e, t) {
        if (e) {
          if (t(e)) return e;
          if (e._x_teleportBack && (e = e._x_teleportBack), e.parentElement) return Ee(e.parentElement, t);
        }
      }
      var Ce = [];
      function ke(e, t = ge, r = (() => {})) {
        !function(e) {
          re = !0;
          let t = Symbol();
          ie = t, ne.set(t, []);
          let r = () => {
            for (;ne.get(t).length; ) ne.get(t).shift()();
            ne.delete(t);
          };
          e(r), re = !1, r();
        }((() => {
          t(e, ((e, t) => {
            r(e, t), Ce.forEach((r => r(e, t))), ee(e, e.attributes).forEach((e => e())), e._x_ignore && t();
          }));
        }));
      }
      function Oe(e) {
        ge(e, (e => y(e)));
      }
      var Pe = [], Le = !1;
      function Ae(e = (() => {})) {
        return queueMicrotask((() => {
          Le || setTimeout((() => {
            Te();
          }));
        })), new Promise((t => {
          Pe.push((() => {
            e(), t();
          }));
        }));
      }
      function Te() {
        for (Le = !1; Pe.length; ) Pe.shift()();
      }
      function Ie(e, t) {
        return Array.isArray(t) ? qe(e, t.join(" ")) : "object" == typeof t && null !== t ? function(e, t) {
          let r = e => e.split(" ").filter(Boolean), n = Object.entries(t).flatMap((([e, t]) => !!t && r(e))).filter(Boolean), i = Object.entries(t).flatMap((([e, t]) => !t && r(e))).filter(Boolean), s = [], o = [];
          return i.forEach((t => {
            e.classList.contains(t) && (e.classList.remove(t), o.push(t));
          })), n.forEach((t => {
            e.classList.contains(t) || (e.classList.add(t), s.push(t));
          })), () => {
            o.forEach((t => e.classList.add(t))), s.forEach((t => e.classList.remove(t)));
          };
        }(e, t) : "function" == typeof t ? Ie(e, t()) : qe(e, t);
      }
      function qe(e, t) {
        return t = !0 === t ? t = "" : t || "", r = t.split(" ").filter((t => !e.classList.contains(t))).filter(Boolean), 
        e.classList.add(...r), () => {
          e.classList.remove(...r);
        };
        var r;
      }
      function Me(e, t) {
        return "object" == typeof t && null !== t ? function(e, t) {
          let r = {};
          return Object.entries(t).forEach((([t, n]) => {
            r[t] = e.style[t], t.startsWith("--") || (t = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()), 
            e.style.setProperty(t, n);
          })), setTimeout((() => {
            0 === e.style.length && e.removeAttribute("style");
          })), () => {
            Me(e, r);
          };
        }(e, t) : function(e, t) {
          let r = e.getAttribute("style", t);
          return e.setAttribute("style", t), () => {
            e.setAttribute("style", r || "");
          };
        }(e, t);
      }
      function je(e, t = (() => {})) {
        let r = !1;
        return function() {
          r ? t.apply(this, arguments) : (r = !0, e.apply(this, arguments));
        };
      }
      function Ne(e, t, r = {}) {
        e._x_transition || (e._x_transition = {
          enter: {
            during: r,
            start: r,
            end: r
          },
          leave: {
            during: r,
            start: r,
            end: r
          },
          in(r = (() => {}), n = (() => {})) {
            Re(e, t, {
              during: this.enter.during,
              start: this.enter.start,
              end: this.enter.end
            }, r, n);
          },
          out(r = (() => {}), n = (() => {})) {
            Re(e, t, {
              during: this.leave.during,
              start: this.leave.start,
              end: this.leave.end
            }, r, n);
          }
        });
      }
      function De(e) {
        let t = e.parentNode;
        if (t) return t._x_hidePromise ? t : De(t);
      }
      function Re(e, t, {during: r, start: n, end: i} = {}, s = (() => {}), o = (() => {})) {
        if (e._x_transitioning && e._x_transitioning.cancel(), 0 === Object.keys(r).length && 0 === Object.keys(n).length && 0 === Object.keys(i).length) return s(), 
        void o();
        let a, l, c;
        !function(e, t) {
          let r, n, i, s = je((() => {
            C((() => {
              r = !0, n || t.before(), i || (t.end(), Te()), t.after(), e.isConnected && t.cleanup(), 
              delete e._x_transitioning;
            }));
          }));
          e._x_transitioning = {
            beforeCancels: [],
            beforeCancel(e) {
              this.beforeCancels.push(e);
            },
            cancel: je((function() {
              for (;this.beforeCancels.length; ) this.beforeCancels.shift()();
              s();
            })),
            finish: s
          }, C((() => {
            t.start(), t.during();
          })), Le = !0, requestAnimationFrame((() => {
            if (r) return;
            let s = 1e3 * Number(getComputedStyle(e).transitionDuration.replace(/,.*/, "").replace("s", "")), o = 1e3 * Number(getComputedStyle(e).transitionDelay.replace(/,.*/, "").replace("s", ""));
            0 === s && (s = 1e3 * Number(getComputedStyle(e).animationDuration.replace("s", ""))), 
            C((() => {
              t.before();
            })), n = !0, requestAnimationFrame((() => {
              r || (C((() => {
                t.end();
              })), Te(), setTimeout(e._x_transitioning.finish, s + o), i = !0);
            }));
          }));
        }(e, {
          start() {
            a = t(e, n);
          },
          during() {
            l = t(e, r);
          },
          before: s,
          end() {
            a(), c = t(e, i);
          },
          after: o,
          cleanup() {
            l(), c();
          }
        });
      }
      function Be(e, t, r) {
        if (-1 === e.indexOf(t)) return r;
        const n = e[e.indexOf(t) + 1];
        if (!n) return r;
        if ("scale" === t && isNaN(n)) return r;
        if ("duration" === t) {
          let e = n.match(/([0-9]+)ms/);
          if (e) return e[1];
        }
        return "origin" === t && [ "top", "right", "left", "center", "bottom" ].includes(e[e.indexOf(t) + 2]) ? [ n, e[e.indexOf(t) + 2] ].join(" ") : n;
      }
      X("transition", ((e, {value: t, modifiers: r, expression: n}, {evaluate: i}) => {
        "function" == typeof n && (n = i(n)), n ? function(e, t, r) {
          Ne(e, Ie, "");
          let n = {
            enter: t => {
              e._x_transition.enter.during = t;
            },
            "enter-start": t => {
              e._x_transition.enter.start = t;
            },
            "enter-end": t => {
              e._x_transition.enter.end = t;
            },
            leave: t => {
              e._x_transition.leave.during = t;
            },
            "leave-start": t => {
              e._x_transition.leave.start = t;
            },
            "leave-end": t => {
              e._x_transition.leave.end = t;
            }
          };
          n[r](t);
        }(e, n, t) : function(e, t, r) {
          Ne(e, Me);
          let n = !t.includes("in") && !t.includes("out") && !r, i = n || t.includes("in") || [ "enter" ].includes(r), s = n || t.includes("out") || [ "leave" ].includes(r);
          t.includes("in") && !n && (t = t.filter(((e, r) => r < t.indexOf("out"))));
          t.includes("out") && !n && (t = t.filter(((e, r) => r > t.indexOf("out"))));
          let o = !t.includes("opacity") && !t.includes("scale"), a = o || t.includes("opacity"), l = o || t.includes("scale"), c = a ? 0 : 1, d = l ? Be(t, "scale", 95) / 100 : 1, u = Be(t, "delay", 0), h = Be(t, "origin", "center"), f = "opacity, transform", p = Be(t, "duration", 150) / 1e3, m = Be(t, "duration", 75) / 1e3, g = "cubic-bezier(0.4, 0.0, 0.2, 1)";
          i && (e._x_transition.enter.during = {
            transformOrigin: h,
            transitionDelay: u,
            transitionProperty: f,
            transitionDuration: `${p}s`,
            transitionTimingFunction: g
          }, e._x_transition.enter.start = {
            opacity: c,
            transform: `scale(${d})`
          }, e._x_transition.enter.end = {
            opacity: 1,
            transform: "scale(1)"
          });
          s && (e._x_transition.leave.during = {
            transformOrigin: h,
            transitionDelay: u,
            transitionProperty: f,
            transitionDuration: `${m}s`,
            transitionTimingFunction: g
          }, e._x_transition.leave.start = {
            opacity: 1,
            transform: "scale(1)"
          }, e._x_transition.leave.end = {
            opacity: c,
            transform: `scale(${d})`
          });
        }(e, r, t);
      })), window.Element.prototype._x_toggleAndCascadeWithTransitions = function(e, t, r, n) {
        const i = "visible" === document.visibilityState ? requestAnimationFrame : setTimeout;
        let s = () => i(r);
        t ? e._x_transition && (e._x_transition.enter || e._x_transition.leave) ? e._x_transition.enter && (Object.entries(e._x_transition.enter.during).length || Object.entries(e._x_transition.enter.start).length || Object.entries(e._x_transition.enter.end).length) ? e._x_transition.in(r) : s() : e._x_transition ? e._x_transition.in(r) : s() : (e._x_hidePromise = e._x_transition ? new Promise(((t, r) => {
          e._x_transition.out((() => {}), (() => t(n))), e._x_transitioning.beforeCancel((() => r({
            isFromCancelledTransition: !0
          })));
        })) : Promise.resolve(n), queueMicrotask((() => {
          let t = De(e);
          t ? (t._x_hideChildren || (t._x_hideChildren = []), t._x_hideChildren.push(e)) : i((() => {
            let t = e => {
              let r = Promise.all([ e._x_hidePromise, ...(e._x_hideChildren || []).map(t) ]).then((([e]) => e()));
              return delete e._x_hidePromise, delete e._x_hideChildren, r;
            };
            t(e).catch((e => {
              if (!e.isFromCancelledTransition) throw e;
            }));
          }));
        })));
      };
      var He = !1;
      function Fe(e, t = (() => {})) {
        return (...r) => He ? t(...r) : e(...r);
      }
      function ze(e, t, r, i = []) {
        switch (e._x_bindings || (e._x_bindings = n({})), e._x_bindings[t] = r, t = i.includes("camel") ? t.toLowerCase().replace(/-(\w)/g, ((e, t) => t.toUpperCase())) : t) {
         case "value":
          !function(e, t) {
            if ("radio" === e.type) void 0 === e.attributes.value && (e.value = t), window.fromModel && (e.checked = Ve(e.value, t)); else if ("checkbox" === e.type) Number.isInteger(t) ? e.value = t : Number.isInteger(t) || Array.isArray(t) || "boolean" == typeof t || [ null, void 0 ].includes(t) ? Array.isArray(t) ? e.checked = t.some((t => Ve(t, e.value))) : e.checked = !!t : e.value = String(t); else if ("SELECT" === e.tagName) !function(e, t) {
              const r = [].concat(t).map((e => e + ""));
              Array.from(e.options).forEach((e => {
                e.selected = r.includes(e.value);
              }));
            }(e, t); else {
              if (e.value === t) return;
              e.value = t;
            }
          }(e, r);
          break;

         case "style":
          !function(e, t) {
            e._x_undoAddedStyles && e._x_undoAddedStyles();
            e._x_undoAddedStyles = Me(e, t);
          }(e, r);
          break;

         case "class":
          !function(e, t) {
            e._x_undoAddedClasses && e._x_undoAddedClasses();
            e._x_undoAddedClasses = Ie(e, t);
          }(e, r);
          break;

         default:
          !function(e, t, r) {
            [ null, void 0, !1 ].includes(r) && function(e) {
              return ![ "aria-pressed", "aria-checked", "aria-expanded", "aria-selected" ].includes(e);
            }(t) ? e.removeAttribute(t) : (We(t) && (r = t), function(e, t, r) {
              e.getAttribute(t) != r && e.setAttribute(t, r);
            }(e, t, r));
          }(e, t, r);
        }
      }
      function Ve(e, t) {
        return e == t;
      }
      function We(e) {
        return [ "disabled", "checked", "required", "readonly", "hidden", "open", "selected", "autofocus", "itemscope", "multiple", "novalidate", "allowfullscreen", "allowpaymentrequest", "formnovalidate", "autoplay", "controls", "loop", "muted", "playsinline", "default", "ismap", "reversed", "async", "defer", "nomodule" ].includes(e);
      }
      function Ue(e, t) {
        var r;
        return function() {
          var n = this, i = arguments;
          clearTimeout(r), r = setTimeout((function() {
            r = null, e.apply(n, i);
          }), t);
        };
      }
      function Je(e, t) {
        let r;
        return function() {
          let n = this, i = arguments;
          r || (e.apply(n, i), r = !0, setTimeout((() => r = !1), t));
        };
      }
      var Ke = {}, Ge = !1;
      var Ze = {};
      function Ye(e, t, r) {
        let n = [];
        for (;n.length; ) n.pop()();
        let i = Object.entries(t).map((([e, t]) => ({
          name: e,
          value: t
        }))), s = te(i);
        i = i.map((e => s.find((t => t.name === e.name)) ? {
          name: `x-bind:${e.name}`,
          value: `"${e.value}"`
        } : e)), ee(e, i, r).map((e => {
          n.push(e.runCleanups), e();
        }));
      }
      var Qe = {};
      var Xe = {
        get reactive() {
          return n;
        },
        get release() {
          return s;
        },
        get effect() {
          return i;
        },
        get raw() {
          return o;
        },
        version: "3.11.1",
        flushAndStopDeferringMutations: function() {
          k = !1, P(O), O = [];
        },
        dontAutoEvaluateFunctions: function(e) {
          let t = z;
          z = !1, e(), z = t;
        },
        disableEffectScheduling: function(e) {
          f = !1, e(), f = !0;
        },
        startObservingMutations: w,
        stopObservingMutations: $,
        setReactivityEngine: function(e) {
          n = e.reactive, s = e.release, i = t => e.effect(t, {
            scheduler: e => {
              f ? d(e) : e();
            }
          }), o = e.raw;
        },
        closestDataStack: I,
        skipDuringClone: Fe,
        onlyDuringClone: function(e) {
          return (...t) => He && e(...t);
        },
        addRootSelector: we,
        addInitSelector: $e,
        addScopeToNode: A,
        deferMutations: function() {
          k = !0;
        },
        mapAttributes: ce,
        evaluateLater: W,
        interceptInit: function(e) {
          Ce.push(e);
        },
        setEvaluator: function(e) {
          U = e;
        },
        mergeProxies: q,
        findClosest: Ee,
        closestRoot: Se,
        destroyTree: Oe,
        interceptor: j,
        transition: Re,
        setStyles: Me,
        mutateDom: C,
        directive: X,
        throttle: Je,
        debounce: Ue,
        evaluate: V,
        initTree: ke,
        nextTick: Ae,
        prefixed: Y,
        prefix: function(e) {
          Z = e;
        },
        plugin: function(e) {
          e(Xe);
        },
        magic: R,
        store: function(e, t) {
          if (Ge || (Ke = n(Ke), Ge = !0), void 0 === t) return Ke[e];
          Ke[e] = t, "object" == typeof t && null !== t && t.hasOwnProperty("init") && "function" == typeof t.init && Ke[e].init(), 
          M(Ke[e]);
        },
        start: function() {
          var e;
          document.body || _e("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"), 
          me(document, "alpine:init"), me(document, "alpine:initializing"), w(), e = e => ke(e, ge), 
          _.push(e), v((e => Oe(e))), function(e) {
            m.push(e);
          }(((e, t) => {
            ee(e, t).forEach((e => e()));
          })), Array.from(document.querySelectorAll(be())).filter((e => !Se(e.parentElement, !0))).forEach((e => {
            ke(e);
          })), me(document, "alpine:initialized");
        },
        clone: function(e, t) {
          t._x_dataStack || (t._x_dataStack = e._x_dataStack), He = !0, function(e) {
            let t = i;
            p(((e, r) => {
              let n = t(e);
              return s(n), () => {};
            })), e(), p(t);
          }((() => {
            !function(e) {
              let t = !1;
              ke(e, ((e, r) => {
                ge(e, ((e, n) => {
                  if (t && function(e) {
                    return xe().some((t => e.matches(t)));
                  }(e)) return n();
                  t = !0, r(e, n);
                }));
              }));
            }(t);
          })), He = !1;
        },
        bound: function(e, t, r) {
          if (e._x_bindings && void 0 !== e._x_bindings[t]) return e._x_bindings[t];
          let n = e.getAttribute(t);
          return null === n ? "function" == typeof r ? r() : r : "" === n || (We(t) ? !![ t, "true" ].includes(n) : n);
        },
        $data: L,
        walk: ge,
        data: function(e, t) {
          Qe[e] = t;
        },
        bind: function(e, t) {
          let r = "function" != typeof t ? () => t : t;
          e instanceof Element ? Ye(e, r()) : Ze[e] = r;
        }
      };
      function et(e, t) {
        const r = Object.create(null), n = e.split(",");
        for (let e = 0; e < n.length; e++) r[n[e]] = !0;
        return t ? e => !!r[e.toLowerCase()] : e => !!r[e];
      }
      var tt, rt = Object.freeze({}), nt = (Object.freeze([]), Object.assign), it = Object.prototype.hasOwnProperty, st = (e, t) => it.call(e, t), ot = Array.isArray, at = e => "[object Map]" === ut(e), lt = e => "symbol" == typeof e, ct = e => null !== e && "object" == typeof e, dt = Object.prototype.toString, ut = e => dt.call(e), ht = e => ut(e).slice(8, -1), ft = e => "string" == typeof e && "NaN" !== e && "-" !== e[0] && "" + parseInt(e, 10) === e, pt = e => {
        const t = Object.create(null);
        return r => t[r] || (t[r] = e(r));
      }, mt = /-(\w)/g, gt = (pt((e => e.replace(mt, ((e, t) => t ? t.toUpperCase() : "")))), 
      /\B([A-Z])/g), _t = (pt((e => e.replace(gt, "-$1").toLowerCase())), pt((e => e.charAt(0).toUpperCase() + e.slice(1)))), vt = (pt((e => e ? `on${_t(e)}` : "")), 
      (e, t) => e !== t && (e == e || t == t)), yt = new WeakMap, xt = [], bt = Symbol("iterate"), wt = Symbol("Map key iterate");
      var $t = 0;
      function St(e) {
        const {deps: t} = e;
        if (t.length) {
          for (let r = 0; r < t.length; r++) t[r].delete(e);
          t.length = 0;
        }
      }
      var Et = !0, Ct = [];
      function kt() {
        const e = Ct.pop();
        Et = void 0 === e || e;
      }
      function Ot(e, t, r) {
        if (!Et || void 0 === tt) return;
        let n = yt.get(e);
        n || yt.set(e, n = new Map);
        let i = n.get(r);
        i || n.set(r, i = new Set), i.has(tt) || (i.add(tt), tt.deps.push(i), tt.options.onTrack && tt.options.onTrack({
          effect: tt,
          target: e,
          type: t,
          key: r
        }));
      }
      function Pt(e, t, r, n, i, s) {
        const o = yt.get(e);
        if (!o) return;
        const a = new Set, l = e => {
          e && e.forEach((e => {
            (e !== tt || e.allowRecurse) && a.add(e);
          }));
        };
        if ("clear" === t) o.forEach(l); else if ("length" === r && ot(e)) o.forEach(((e, t) => {
          ("length" === t || t >= n) && l(e);
        })); else switch (void 0 !== r && l(o.get(r)), t) {
         case "add":
          ot(e) ? ft(r) && l(o.get("length")) : (l(o.get(bt)), at(e) && l(o.get(wt)));
          break;

         case "delete":
          ot(e) || (l(o.get(bt)), at(e) && l(o.get(wt)));
          break;

         case "set":
          at(e) && l(o.get(bt));
        }
        a.forEach((o => {
          o.options.onTrigger && o.options.onTrigger({
            effect: o,
            target: e,
            key: r,
            type: t,
            newValue: n,
            oldValue: i,
            oldTarget: s
          }), o.options.scheduler ? o.options.scheduler(o) : o();
        }));
      }
      var Lt = et("__proto__,__v_isRef,__isVue"), At = new Set(Object.getOwnPropertyNames(Symbol).map((e => Symbol[e])).filter(lt)), Tt = Nt(), It = Nt(!1, !0), qt = Nt(!0), Mt = Nt(!0, !0), jt = {};
      function Nt(e = !1, t = !1) {
        return function(r, n, i) {
          if ("__v_isReactive" === n) return !e;
          if ("__v_isReadonly" === n) return e;
          if ("__v_raw" === n && i === (e ? t ? hr : ur : t ? dr : cr).get(r)) return r;
          const s = ot(r);
          if (!e && s && st(jt, n)) return Reflect.get(jt, n, i);
          const o = Reflect.get(r, n, i);
          if (lt(n) ? At.has(n) : Lt(n)) return o;
          if (e || Ot(r, "get", n), t) return o;
          if (_r(o)) {
            return !s || !ft(n) ? o.value : o;
          }
          return ct(o) ? e ? pr(o) : fr(o) : o;
        };
      }
      function Dt(e = !1) {
        return function(t, r, n, i) {
          let s = t[r];
          if (!e && (n = gr(n), s = gr(s), !ot(t) && _r(s) && !_r(n))) return s.value = n, 
          !0;
          const o = ot(t) && ft(r) ? Number(r) < t.length : st(t, r), a = Reflect.set(t, r, n, i);
          return t === gr(i) && (o ? vt(n, s) && Pt(t, "set", r, n, s) : Pt(t, "add", r, n)), 
          a;
        };
      }
      [ "includes", "indexOf", "lastIndexOf" ].forEach((e => {
        const t = Array.prototype[e];
        jt[e] = function(...e) {
          const r = gr(this);
          for (let e = 0, t = this.length; e < t; e++) Ot(r, "get", e + "");
          const n = t.apply(r, e);
          return -1 === n || !1 === n ? t.apply(r, e.map(gr)) : n;
        };
      })), [ "push", "pop", "shift", "unshift", "splice" ].forEach((e => {
        const t = Array.prototype[e];
        jt[e] = function(...e) {
          Ct.push(Et), Et = !1;
          const r = t.apply(this, e);
          return kt(), r;
        };
      }));
      var Rt = {
        get: Tt,
        set: Dt(),
        deleteProperty: function(e, t) {
          const r = st(e, t), n = e[t], i = Reflect.deleteProperty(e, t);
          return i && r && Pt(e, "delete", t, void 0, n), i;
        },
        has: function(e, t) {
          const r = Reflect.has(e, t);
          return lt(t) && At.has(t) || Ot(e, "has", t), r;
        },
        ownKeys: function(e) {
          return Ot(e, "iterate", ot(e) ? "length" : bt), Reflect.ownKeys(e);
        }
      }, Bt = {
        get: qt,
        set(e, t) {
          return console.warn(`Set operation on key "${String(t)}" failed: target is readonly.`, e), 
          !0;
        },
        deleteProperty(e, t) {
          return console.warn(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), 
          !0;
        }
      }, Ht = (nt({}, Rt, {
        get: It,
        set: Dt(!0)
      }), nt({}, Bt, {
        get: Mt
      }), e => ct(e) ? fr(e) : e), Ft = e => ct(e) ? pr(e) : e, zt = e => e, Vt = e => Reflect.getPrototypeOf(e);
      function Wt(e, t, r = !1, n = !1) {
        const i = gr(e = e.__v_raw), s = gr(t);
        t !== s && !r && Ot(i, "get", t), !r && Ot(i, "get", s);
        const {has: o} = Vt(i), a = n ? zt : r ? Ft : Ht;
        return o.call(i, t) ? a(e.get(t)) : o.call(i, s) ? a(e.get(s)) : void (e !== i && e.get(t));
      }
      function Ut(e, t = !1) {
        const r = this.__v_raw, n = gr(r), i = gr(e);
        return e !== i && !t && Ot(n, "has", e), !t && Ot(n, "has", i), e === i ? r.has(e) : r.has(e) || r.has(i);
      }
      function Jt(e, t = !1) {
        return e = e.__v_raw, !t && Ot(gr(e), "iterate", bt), Reflect.get(e, "size", e);
      }
      function Kt(e) {
        e = gr(e);
        const t = gr(this);
        return Vt(t).has.call(t, e) || (t.add(e), Pt(t, "add", e, e)), this;
      }
      function Gt(e, t) {
        t = gr(t);
        const r = gr(this), {has: n, get: i} = Vt(r);
        let s = n.call(r, e);
        s ? lr(r, n, e) : (e = gr(e), s = n.call(r, e));
        const o = i.call(r, e);
        return r.set(e, t), s ? vt(t, o) && Pt(r, "set", e, t, o) : Pt(r, "add", e, t), 
        this;
      }
      function Zt(e) {
        const t = gr(this), {has: r, get: n} = Vt(t);
        let i = r.call(t, e);
        i ? lr(t, r, e) : (e = gr(e), i = r.call(t, e));
        const s = n ? n.call(t, e) : void 0, o = t.delete(e);
        return i && Pt(t, "delete", e, void 0, s), o;
      }
      function Yt() {
        const e = gr(this), t = 0 !== e.size, r = at(e) ? new Map(e) : new Set(e), n = e.clear();
        return t && Pt(e, "clear", void 0, void 0, r), n;
      }
      function Qt(e, t) {
        return function(r, n) {
          const i = this, s = i.__v_raw, o = gr(s), a = t ? zt : e ? Ft : Ht;
          return !e && Ot(o, "iterate", bt), s.forEach(((e, t) => r.call(n, a(e), a(t), i)));
        };
      }
      function Xt(e, t, r) {
        return function(...n) {
          const i = this.__v_raw, s = gr(i), o = at(s), a = "entries" === e || e === Symbol.iterator && o, l = "keys" === e && o, c = i[e](...n), d = r ? zt : t ? Ft : Ht;
          return !t && Ot(s, "iterate", l ? wt : bt), {
            next() {
              const {value: e, done: t} = c.next();
              return t ? {
                value: e,
                done: t
              } : {
                value: a ? [ d(e[0]), d(e[1]) ] : d(e),
                done: t
              };
            },
            [Symbol.iterator]() {
              return this;
            }
          };
        };
      }
      function er(e) {
        return function(...t) {
          {
            const r = t[0] ? `on key "${t[0]}" ` : "";
            console.warn(`${_t(e)} operation ${r}failed: target is readonly.`, gr(this));
          }
          return "delete" !== e && this;
        };
      }
      var tr = {
        get(e) {
          return Wt(this, e);
        },
        get size() {
          return Jt(this);
        },
        has: Ut,
        add: Kt,
        set: Gt,
        delete: Zt,
        clear: Yt,
        forEach: Qt(!1, !1)
      }, rr = {
        get(e) {
          return Wt(this, e, !1, !0);
        },
        get size() {
          return Jt(this);
        },
        has: Ut,
        add: Kt,
        set: Gt,
        delete: Zt,
        clear: Yt,
        forEach: Qt(!1, !0)
      }, nr = {
        get(e) {
          return Wt(this, e, !0);
        },
        get size() {
          return Jt(this, !0);
        },
        has(e) {
          return Ut.call(this, e, !0);
        },
        add: er("add"),
        set: er("set"),
        delete: er("delete"),
        clear: er("clear"),
        forEach: Qt(!0, !1)
      }, ir = {
        get(e) {
          return Wt(this, e, !0, !0);
        },
        get size() {
          return Jt(this, !0);
        },
        has(e) {
          return Ut.call(this, e, !0);
        },
        add: er("add"),
        set: er("set"),
        delete: er("delete"),
        clear: er("clear"),
        forEach: Qt(!0, !0)
      };
      function sr(e, t) {
        const r = t ? e ? ir : rr : e ? nr : tr;
        return (t, n, i) => "__v_isReactive" === n ? !e : "__v_isReadonly" === n ? e : "__v_raw" === n ? t : Reflect.get(st(r, n) && n in t ? r : t, n, i);
      }
      [ "keys", "values", "entries", Symbol.iterator ].forEach((e => {
        tr[e] = Xt(e, !1, !1), nr[e] = Xt(e, !0, !1), rr[e] = Xt(e, !1, !0), ir[e] = Xt(e, !0, !0);
      }));
      var or = {
        get: sr(!1, !1)
      }, ar = (sr(!1, !0), {
        get: sr(!0, !1)
      });
      sr(!0, !0);
      function lr(e, t, r) {
        const n = gr(r);
        if (n !== r && t.call(e, n)) {
          const t = ht(e);
          console.warn(`Reactive ${t} contains both the raw and reactive versions of the same object${"Map" === t ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
        }
      }
      var cr = new WeakMap, dr = new WeakMap, ur = new WeakMap, hr = new WeakMap;
      function fr(e) {
        return e && e.__v_isReadonly ? e : mr(e, !1, Rt, or, cr);
      }
      function pr(e) {
        return mr(e, !0, Bt, ar, ur);
      }
      function mr(e, t, r, n, i) {
        if (!ct(e)) return console.warn(`value cannot be made reactive: ${String(e)}`), 
        e;
        if (e.__v_raw && (!t || !e.__v_isReactive)) return e;
        const s = i.get(e);
        if (s) return s;
        const o = (a = e).__v_skip || !Object.isExtensible(a) ? 0 : function(e) {
          switch (e) {
           case "Object":
           case "Array":
            return 1;

           case "Map":
           case "Set":
           case "WeakMap":
           case "WeakSet":
            return 2;

           default:
            return 0;
          }
        }(ht(a));
        var a;
        if (0 === o) return e;
        const l = new Proxy(e, 2 === o ? n : r);
        return i.set(e, l), l;
      }
      function gr(e) {
        return e && gr(e.__v_raw) || e;
      }
      function _r(e) {
        return Boolean(e && !0 === e.__v_isRef);
      }
      R("nextTick", (() => Ae)), R("dispatch", (e => me.bind(me, e))), R("watch", ((e, {evaluateLater: t, effect: r}) => (n, i) => {
        let s, o = t(n), a = !0, l = r((() => o((e => {
          JSON.stringify(e), a ? s = e : queueMicrotask((() => {
            i(e, s), s = e;
          })), a = !1;
        }))));
        e._x_effects.delete(l);
      })), R("store", (function() {
        return Ke;
      })), R("data", (e => L(e))), R("root", (e => Se(e))), R("refs", (e => (e._x_refs_proxy || (e._x_refs_proxy = q(function(e) {
        let t = [], r = e;
        for (;r; ) r._x_refs && t.push(r._x_refs), r = r.parentNode;
        return t;
      }(e))), e._x_refs_proxy)));
      var vr = {};
      function yr(e) {
        return vr[e] || (vr[e] = 0), ++vr[e];
      }
      function xr(e, t, r) {
        R(t, (t => _e(`You can't use [$${directiveName}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${r}`, t)));
      }
      R("id", (e => (t, r = null) => {
        let n = function(e, t) {
          return Ee(e, (e => {
            if (e._x_ids && e._x_ids[t]) return !0;
          }));
        }(e, t), i = n ? n._x_ids[t] : yr(t);
        return r ? `${t}-${i}-${r}` : `${t}-${i}`;
      })), R("el", (e => e)), xr("Focus", "focus", "focus"), xr("Persist", "persist", "persist"), 
      X("modelable", ((e, {expression: t}, {effect: r, evaluateLater: n, cleanup: o}) => {
        let a = n(t), l = () => {
          let e;
          return a((t => e = t)), e;
        }, c = n(`${t} = __placeholder`), d = e => c((() => {}), {
          scope: {
            __placeholder: e
          }
        }), u = l();
        d(u), queueMicrotask((() => {
          if (!e._x_model) return;
          e._x_removeModelListeners.default();
          let t = e._x_model.get, r = e._x_model.set, n = function({get: e, set: t}, {get: r, set: n}) {
            let o, a, l, c, d = !0, u = i((() => {
              let i, s;
              d ? (i = e(), n(i), s = r(), d = !1) : (i = e(), s = r(), l = JSON.stringify(i), 
              c = JSON.stringify(s), l !== o ? (s = r(), n(i), s = i) : (t(s), i = s)), o = JSON.stringify(i), 
              a = JSON.stringify(s);
            }));
            return () => {
              s(u);
            };
          }({
            get() {
              return t();
            },
            set(e) {
              r(e);
            }
          }, {
            get() {
              return l();
            },
            set(e) {
              d(e);
            }
          });
          o(n);
        }));
      }));
      var br = document.createElement("div");
      X("teleport", ((e, {modifiers: t, expression: r}, {cleanup: n}) => {
        "template" !== e.tagName.toLowerCase() && _e("x-teleport can only be used on a <template> tag", e);
        let i = Fe((() => document.querySelector(r)), (() => br))();
        i || _e(`Cannot find x-teleport element for selector: "${r}"`);
        let s = e.content.cloneNode(!0).firstElementChild;
        e._x_teleport = s, s._x_teleportBack = e, e._x_forwardEvents && e._x_forwardEvents.forEach((t => {
          s.addEventListener(t, (t => {
            t.stopPropagation(), e.dispatchEvent(new t.constructor(t.type, t));
          }));
        })), A(s, {}, e), C((() => {
          t.includes("prepend") ? i.parentNode.insertBefore(s, i) : t.includes("append") ? i.parentNode.insertBefore(s, i.nextSibling) : i.appendChild(s), 
          ke(s), s._x_ignore = !0;
        })), n((() => s.remove()));
      }));
      var wr = () => {};
      function $r(e, t, r, n) {
        let i = e, s = e => n(e), o = {}, a = (e, t) => r => t(e, r);
        if (r.includes("dot") && (t = t.replace(/-/g, ".")), r.includes("camel") && (t = function(e) {
          return e.toLowerCase().replace(/-(\w)/g, ((e, t) => t.toUpperCase()));
        }(t)), r.includes("passive") && (o.passive = !0), r.includes("capture") && (o.capture = !0), 
        r.includes("window") && (i = window), r.includes("document") && (i = document), 
        r.includes("prevent") && (s = a(s, ((e, t) => {
          t.preventDefault(), e(t);
        }))), r.includes("stop") && (s = a(s, ((e, t) => {
          t.stopPropagation(), e(t);
        }))), r.includes("self") && (s = a(s, ((t, r) => {
          r.target === e && t(r);
        }))), (r.includes("away") || r.includes("outside")) && (i = document, s = a(s, ((t, r) => {
          e.contains(r.target) || !1 !== r.target.isConnected && (e.offsetWidth < 1 && e.offsetHeight < 1 || !1 !== e._x_isShown && t(r));
        }))), r.includes("once") && (s = a(s, ((e, r) => {
          e(r), i.removeEventListener(t, s, o);
        }))), s = a(s, ((e, n) => {
          (function(e) {
            return [ "keydown", "keyup" ].includes(e);
          })(t) && function(e, t) {
            let r = t.filter((e => ![ "window", "document", "prevent", "stop", "once" ].includes(e)));
            if (r.includes("debounce")) {
              let e = r.indexOf("debounce");
              r.splice(e, Sr((r[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
            }
            if (r.includes("throttle")) {
              let e = r.indexOf("throttle");
              r.splice(e, Sr((r[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
            }
            if (0 === r.length) return !1;
            if (1 === r.length && Er(e.key).includes(r[0])) return !1;
            const n = [ "ctrl", "shift", "alt", "meta", "cmd", "super" ].filter((e => r.includes(e)));
            if (r = r.filter((e => !n.includes(e))), n.length > 0) {
              if (n.filter((t => ("cmd" !== t && "super" !== t || (t = "meta"), e[`${t}Key`]))).length === n.length && Er(e.key).includes(r[0])) return !1;
            }
            return !0;
          }(n, r) || e(n);
        })), r.includes("debounce")) {
          let e = r[r.indexOf("debounce") + 1] || "invalid-wait", t = Sr(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
          s = Ue(s, t);
        }
        if (r.includes("throttle")) {
          let e = r[r.indexOf("throttle") + 1] || "invalid-wait", t = Sr(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
          s = Je(s, t);
        }
        return i.addEventListener(t, s, o), () => {
          i.removeEventListener(t, s, o);
        };
      }
      function Sr(e) {
        return !Array.isArray(e) && !isNaN(e);
      }
      function Er(e) {
        if (!e) return [];
        var t;
        e = [ " ", "_" ].includes(t = e) ? t : t.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
        let r = {
          ctrl: "control",
          slash: "/",
          space: " ",
          spacebar: " ",
          cmd: "meta",
          esc: "escape",
          up: "arrow-up",
          down: "arrow-down",
          left: "arrow-left",
          right: "arrow-right",
          period: ".",
          equal: "=",
          minus: "-",
          underscore: "_"
        };
        return r[e] = e, Object.keys(r).map((t => {
          if (r[t] === e) return t;
        })).filter((e => e));
      }
      function Cr(e) {
        let t = e ? parseFloat(e) : null;
        return r = t, Array.isArray(r) || isNaN(r) ? e : t;
        var r;
      }
      function kr(e) {
        return null !== e && "object" == typeof e && "function" == typeof e.get && "function" == typeof e.set;
      }
      function Or(e, t, r, n) {
        let i = {};
        if (/^\[.*\]$/.test(e.item) && Array.isArray(t)) {
          e.item.replace("[", "").replace("]", "").split(",").map((e => e.trim())).forEach(((e, r) => {
            i[e] = t[r];
          }));
        } else if (/^\{.*\}$/.test(e.item) && !Array.isArray(t) && "object" == typeof t) {
          e.item.replace("{", "").replace("}", "").split(",").map((e => e.trim())).forEach((e => {
            i[e] = t[e];
          }));
        } else i[e.item] = t;
        return e.index && (i[e.index] = r), e.collection && (i[e.collection] = n), i;
      }
      function Pr() {}
      function Lr(e, t, r) {
        X(t, (n => _e(`You can't use [x-${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${r}`, n)));
      }
      wr.inline = (e, {modifiers: t}, {cleanup: r}) => {
        t.includes("self") ? e._x_ignoreSelf = !0 : e._x_ignore = !0, r((() => {
          t.includes("self") ? delete e._x_ignoreSelf : delete e._x_ignore;
        }));
      }, X("ignore", wr), X("effect", ((e, {expression: t}, {effect: r}) => r(W(e, t)))), 
      X("model", ((e, {modifiers: t, expression: r}, {effect: n, cleanup: i}) => {
        let s = e;
        t.includes("parent") && (s = e.parentNode);
        let o, a = W(s, r);
        o = "string" == typeof r ? W(s, `${r} = __placeholder`) : "function" == typeof r && "string" == typeof r() ? W(s, `${r()} = __placeholder`) : () => {};
        let l = () => {
          let e;
          return a((t => e = t)), kr(e) ? e.get() : e;
        }, c = e => {
          let t;
          a((e => t = e)), kr(t) ? t.set(e) : o((() => {}), {
            scope: {
              __placeholder: e
            }
          });
        };
        "string" == typeof r && "radio" === e.type && C((() => {
          e.hasAttribute("name") || e.setAttribute("name", r);
        }));
        var d = "select" === e.tagName.toLowerCase() || [ "checkbox", "radio" ].includes(e.type) || t.includes("lazy") ? "change" : "input";
        let u = $r(e, d, t, (r => {
          c(function(e, t, r, n) {
            return C((() => {
              if (r instanceof CustomEvent && void 0 !== r.detail) return void 0 !== r.detail ? r.detail : r.target.value;
              if ("checkbox" === e.type) {
                if (Array.isArray(n)) {
                  let e = t.includes("number") ? Cr(r.target.value) : r.target.value;
                  return r.target.checked ? n.concat([ e ]) : n.filter((t => !(t == e)));
                }
                return r.target.checked;
              }
              if ("select" === e.tagName.toLowerCase() && e.multiple) return t.includes("number") ? Array.from(r.target.selectedOptions).map((e => Cr(e.value || e.text))) : Array.from(r.target.selectedOptions).map((e => e.value || e.text));
              {
                let e = r.target.value;
                return t.includes("number") ? Cr(e) : t.includes("trim") ? e.trim() : e;
              }
            }));
          }(e, t, r, l()));
        }));
        if (e._x_removeModelListeners || (e._x_removeModelListeners = {}), e._x_removeModelListeners.default = u, 
        i((() => e._x_removeModelListeners.default())), e.form) {
          let t = $r(e.form, "reset", [], (t => {
            Ae((() => e._x_model && e._x_model.set(e.value)));
          }));
          i((() => t()));
        }
        e._x_model = {
          get() {
            return l();
          },
          set(e) {
            c(e);
          }
        }, e._x_forceModelUpdate = t => {
          void 0 === (t = void 0 === t ? l() : t) && "string" == typeof r && r.match(/\./) && (t = ""), 
          window.fromModel = !0, C((() => ze(e, "value", t))), delete window.fromModel;
        }, n((() => {
          let r = l();
          t.includes("unintrusive") && document.activeElement.isSameNode(e) || e._x_forceModelUpdate(r);
        }));
      })), X("cloak", (e => queueMicrotask((() => C((() => e.removeAttribute(Y("cloak")))))))), 
      $e((() => `[${Y("init")}]`)), X("init", Fe(((e, {expression: t}, {evaluate: r}) => "string" == typeof t ? !!t.trim() && r(t, {}, !1) : r(t, {}, !1)))), 
      X("text", ((e, {expression: t}, {effect: r, evaluateLater: n}) => {
        let i = n(t);
        r((() => {
          i((t => {
            C((() => {
              e.textContent = t;
            }));
          }));
        }));
      })), X("html", ((e, {expression: t}, {effect: r, evaluateLater: n}) => {
        let i = n(t);
        r((() => {
          i((t => {
            C((() => {
              e.innerHTML = t, e._x_ignoreSelf = !0, ke(e), delete e._x_ignoreSelf;
            }));
          }));
        }));
      })), ce(oe(":", Y("bind:"))), X("bind", ((e, {value: t, modifiers: r, expression: n, original: i}, {effect: s}) => {
        if (!t) {
          let t = {};
          return o = t, Object.entries(Ze).forEach((([e, t]) => {
            Object.defineProperty(o, e, {
              get() {
                return (...e) => t(...e);
              }
            });
          })), void W(e, n)((t => {
            Ye(e, t, i);
          }), {
            scope: t
          });
        }
        var o;
        if ("key" === t) return function(e, t) {
          e._x_keyExpression = t;
        }(e, n);
        let a = W(e, n);
        s((() => a((i => {
          void 0 === i && "string" == typeof n && n.match(/\./) && (i = ""), C((() => ze(e, t, i, r)));
        }))));
      })), we((() => `[${Y("data")}]`)), X("data", Fe(((e, {expression: t}, {cleanup: r}) => {
        t = "" === t ? "{}" : t;
        let i = {};
        B(i, e);
        let s = {};
        var o, a;
        o = s, a = i, Object.entries(Qe).forEach((([e, t]) => {
          Object.defineProperty(o, e, {
            get() {
              return (...e) => t.bind(a)(...e);
            },
            enumerable: !1
          });
        }));
        let l = V(e, t, {
          scope: s
        });
        void 0 === l && (l = {}), B(l, e);
        let c = n(l);
        M(c);
        let d = A(e, c);
        c.init && V(e, c.init), r((() => {
          c.destroy && V(e, c.destroy), d();
        }));
      }))), X("show", ((e, {modifiers: t, expression: r}, {effect: n}) => {
        let i = W(e, r);
        e._x_doHide || (e._x_doHide = () => {
          C((() => {
            e.style.setProperty("display", "none", t.includes("important") ? "important" : void 0);
          }));
        }), e._x_doShow || (e._x_doShow = () => {
          C((() => {
            1 === e.style.length && "none" === e.style.display ? e.removeAttribute("style") : e.style.removeProperty("display");
          }));
        });
        let s, o = () => {
          e._x_doHide(), e._x_isShown = !1;
        }, a = () => {
          e._x_doShow(), e._x_isShown = !0;
        }, l = () => setTimeout(a), c = je((e => e ? a() : o()), (t => {
          "function" == typeof e._x_toggleAndCascadeWithTransitions ? e._x_toggleAndCascadeWithTransitions(e, t, a, o) : t ? l() : o();
        })), d = !0;
        n((() => i((e => {
          (d || e !== s) && (t.includes("immediate") && (e ? l() : o()), c(e), s = e, d = !1);
        }))));
      })), X("for", ((e, {expression: t}, {effect: r, cleanup: i}) => {
        let s = function(e) {
          let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/, r = /^\s*\(|\)\s*$/g, n = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/, i = e.match(n);
          if (!i) return;
          let s = {};
          s.items = i[2].trim();
          let o = i[1].replace(r, "").trim(), a = o.match(t);
          a ? (s.item = o.replace(t, "").trim(), s.index = a[1].trim(), a[2] && (s.collection = a[2].trim())) : s.item = o;
          return s;
        }(t), o = W(e, s.items), a = W(e, e._x_keyExpression || "index");
        e._x_prevKeys = [], e._x_lookup = {}, r((() => function(e, t, r, i) {
          let s = e => "object" == typeof e && !Array.isArray(e), o = e;
          r((r => {
            var a;
            a = r, !Array.isArray(a) && !isNaN(a) && r >= 0 && (r = Array.from(Array(r).keys(), (e => e + 1))), 
            void 0 === r && (r = []);
            let l = e._x_lookup, c = e._x_prevKeys, d = [], h = [];
            if (s(r)) r = Object.entries(r).map((([e, n]) => {
              let s = Or(t, n, e, r);
              i((e => h.push(e)), {
                scope: {
                  index: e,
                  ...s
                }
              }), d.push(s);
            })); else for (let e = 0; e < r.length; e++) {
              let n = Or(t, r[e], e, r);
              i((e => h.push(e)), {
                scope: {
                  index: e,
                  ...n
                }
              }), d.push(n);
            }
            let f = [], p = [], m = [], g = [];
            for (let e = 0; e < c.length; e++) {
              let t = c[e];
              -1 === h.indexOf(t) && m.push(t);
            }
            c = c.filter((e => !m.includes(e)));
            let _ = "template";
            for (let e = 0; e < h.length; e++) {
              let t = h[e], r = c.indexOf(t);
              if (-1 === r) c.splice(e, 0, t), f.push([ _, e ]); else if (r !== e) {
                let t = c.splice(e, 1)[0], n = c.splice(r - 1, 1)[0];
                c.splice(e, 0, n), c.splice(r, 0, t), p.push([ t, n ]);
              } else g.push(t);
              _ = t;
            }
            for (let e = 0; e < m.length; e++) {
              let t = m[e];
              l[t]._x_effects && l[t]._x_effects.forEach(u), l[t].remove(), l[t] = null, delete l[t];
            }
            for (let e = 0; e < p.length; e++) {
              let [t, r] = p[e], n = l[t], i = l[r], s = document.createElement("div");
              C((() => {
                i.after(s), n.after(i), i._x_currentIfEl && i.after(i._x_currentIfEl), s.before(n), 
                n._x_currentIfEl && n.after(n._x_currentIfEl), s.remove();
              })), T(i, d[h.indexOf(r)]);
            }
            for (let e = 0; e < f.length; e++) {
              let [t, r] = f[e], i = "template" === t ? o : l[t];
              i._x_currentIfEl && (i = i._x_currentIfEl);
              let s = d[r], a = h[r], c = document.importNode(o.content, !0).firstElementChild;
              A(c, n(s), o), C((() => {
                i.after(c), ke(c);
              })), "object" == typeof a && _e("x-for key cannot be an object, it must be a string or an integer", o), 
              l[a] = c;
            }
            for (let e = 0; e < g.length; e++) T(l[g[e]], d[h.indexOf(g[e])]);
            o._x_prevKeys = h;
          }));
        }(e, s, o, a))), i((() => {
          Object.values(e._x_lookup).forEach((e => e.remove())), delete e._x_prevKeys, delete e._x_lookup;
        }));
      })), Pr.inline = (e, {expression: t}, {cleanup: r}) => {
        let n = Se(e);
        n._x_refs || (n._x_refs = {}), n._x_refs[t] = e, r((() => delete n._x_refs[t]));
      }, X("ref", Pr), X("if", ((e, {expression: t}, {effect: r, cleanup: n}) => {
        let i = W(e, t);
        r((() => i((t => {
          t ? (() => {
            if (e._x_currentIfEl) return e._x_currentIfEl;
            let t = e.content.cloneNode(!0).firstElementChild;
            A(t, {}, e), C((() => {
              e.after(t), ke(t);
            })), e._x_currentIfEl = t, e._x_undoIf = () => {
              ge(t, (e => {
                e._x_effects && e._x_effects.forEach(u);
              })), t.remove(), delete e._x_currentIfEl;
            };
          })() : e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf);
        })))), n((() => e._x_undoIf && e._x_undoIf()));
      })), X("id", ((e, {expression: t}, {evaluate: r}) => {
        r(t).forEach((t => function(e, t) {
          e._x_ids || (e._x_ids = {}), e._x_ids[t] || (e._x_ids[t] = yr(t));
        }(e, t)));
      })), ce(oe("@", Y("on:"))), X("on", Fe(((e, {value: t, modifiers: r, expression: n}, {cleanup: i}) => {
        let s = n ? W(e, n) : () => {};
        "template" === e.tagName.toLowerCase() && (e._x_forwardEvents || (e._x_forwardEvents = []), 
        e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
        let o = $r(e, t, r, (e => {
          s((() => {}), {
            scope: {
              $event: e
            },
            params: [ e ]
          });
        }));
        i((() => o()));
      }))), Lr("Collapse", "collapse", "collapse"), Lr("Intersect", "intersect", "intersect"), 
      Lr("Focus", "trap", "focus"), Lr("Mask", "mask", "mask"), Xe.setEvaluator(J), Xe.setReactivityEngine({
        reactive: fr,
        effect: function(e, t = rt) {
          (function(e) {
            return e && !0 === e._isEffect;
          })(e) && (e = e.raw);
          const r = function(e, t) {
            const r = function() {
              if (!r.active) return e();
              if (!xt.includes(r)) {
                St(r);
                try {
                  return Ct.push(Et), Et = !0, xt.push(r), tt = r, e();
                } finally {
                  xt.pop(), kt(), tt = xt[xt.length - 1];
                }
              }
            };
            return r.id = $t++, r.allowRecurse = !!t.allowRecurse, r._isEffect = !0, r.active = !0, 
            r.raw = e, r.deps = [], r.options = t, r;
          }(e, t);
          return t.lazy || r(), r;
        },
        release: function(e) {
          e.active && (St(e), e.options.onStop && e.options.onStop(), e.active = !1);
        },
        raw: gr
      });
      var Ar = Xe;
      function Tr(e, t) {
        return null !== t.getItem(e);
      }
      function Ir(e, t) {
        return JSON.parse(t.getItem(e, t));
      }
      function qr(e, t, r) {
        r.setItem(e, JSON.stringify(t));
      }
      var Mr = function(e) {
        let t = () => {
          let t, r = localStorage;
          return e.interceptor(((n, i, s, o, a) => {
            let l = t || `_x_${o}`, c = Tr(l, r) ? Ir(l, r) : n;
            return s(c), e.effect((() => {
              let e = i();
              qr(l, e, r), s(e);
            })), c;
          }), (e => {
            e.as = r => (t = r, e), e.using = t => (r = t, e);
          }));
        };
        Object.defineProperty(e, "$persist", {
          get: () => t()
        }), e.magic("persist", t), e.persist = (t, {get: r, set: n}, i = localStorage) => {
          let s = Tr(t, i) ? Ir(t, i) : r();
          n(s), e.effect((() => {
            let e = r();
            qr(t, e, i), n(e);
          }));
        };
      }, jr = e => ({
        wrapper: {
          "x-bind:class"() {
            return (this.$store.theme.cart || this.$store.theme.menu || this.$store.theme.mobileMenu || this.$store.theme.filters || this.$store.theme.search || this.$store.theme.sizeChart || this.$store.theme.scrollLock) && "overflow-hidden";
          },
          "x-on:resize.window.debounce"() {
            return this.$store.theme.isTablet() ? this.$store.theme.menu = !1 : this.$store.theme.mobileMenu = !1;
          },
          "x-on:keyup.escape"() {
            this.$store.theme.close();
          }
        },
        anchorLinks() {
          document.querySelector("header");
          document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((e => {
            var t = document.querySelector(e.getAttribute("href"));
            t && e.addEventListener("click", (r => {
              r.preventDefault(), t.scrollIntoView({
                behavior: "smooth",
                block: e.dataset.block || "start",
                inline: e.dataset.inline || "start"
              }), window.dispatchEvent(new Event("scroll"));
            }));
          }));
        },
        init() {
          this.anchorLinks();
        }
      }), Nr = {
        cart: !1,
        menu: !1,
        mobileMenu: !1,
        filters: !1,
        search: !1,
        sizeChart: !1,
        scrollLock: !1,
        recentlyViewed: [],
        cartData: {
          item_count: "",
          total_price: 0,
          items: []
        },
        close() {
          this.cart = this.menu = this.mobileMenu = this.filters = this.search = this.sizeChart = this.scrollLock = !1;
        },
        isTablet() {
          return window.innerWidth < 1024;
        },
        fetchConfig() {
          return {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}`
            }
          };
        },
        getSizedImage(e, t) {
          return e.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".").replace(/\.jpg|\.png|\.gif|\.jpeg/g, (function(e) {
            return "_" + t + e;
          }));
        },
        localReferrer() {
          return !!(document.referrer.includes("duoboots") || document.referrer.includes("shopifypreview.com") || document.referrer.includes("127.0.0.1"));
        },
        async addToCart(e, t) {
          const r = new FormData(e), n = e.querySelector('[type="submit"]');
          n && (n.disabled = !0), fetch(routes.cart_add_url, {
            method: "POST",
            body: new URLSearchParams(r),
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((e => {
            200 === e.status ? window.dispatchEvent(new Event("added")) : console.log(`${e.description}`);
          })).catch((t => e.submit())).finally((() => {
            n && (n.disabled = !1), e.querySelectorAll('input[type="radio"]').forEach((e => e.checked = !1)), 
            t && t();
          }));
        },
        init() {
          this.recentlyViewed = window.Alpine.$persist([]);
        }
      }, Dr = () => window.innerWidth < 720 ? "sm" : window.innerWidth >= 720 && window.innerWidth < 1024 ? "md" : window.innerWidth >= 1024 ? "lg" : void 0, Rr = () => ({
        bound: {
          "@resize.window.debounce"() {
            this.$store.mq = Dr();
          }
        },
        init() {
          this.$store.mq = Dr();
        }
      }), Br = () => ({
        pinned: !1,
        isSearching: !1,
        index: null,
        debouncer: null,
        updateIndex(e) {
          clearTimeout(this.debouncer), this.debouncer = setTimeout((() => {
            this.index = e;
          }), 200);
        },
        handleMouseover() {
          "lg" === this.$store.mq && this.$store.isHeaderTransparent && (this.$store.isHeaderSolid = !0, 
          this.$store.isHeaderDarktheme = !0);
        },
        handleMouseleave() {
          this.$store.isMenuOpen || this.isSearching || !this.$store.isHeaderTransparent || this.$store.isMenuOpen || (this.$store.isHeaderSolid = !1, 
          this.$store.isHeaderDarktheme = this.$store.isHeaderTD);
        },
        handleMenuClick() {
          this.$store.isMenuOpen = !this.$store.isMenuOpen, this.index = null;
        },
        handleSearchClick(e) {
          this.$refs.searchElement.value.replace(/\s/g, "").length || e.preventDefault(), 
          this.isSearching = !this.isSearching, this.$refs.searchElement.focus();
        },
        handleSearchOutsideClick() {
          this.isSearching = !1, this.$refs.searchElement.blur(), this.$refs.searchElement.value = "";
        },
        handleOutsideClick() {
          this.$store.isMenuOpen = !1, this.isSearching = !1, this.index = null, this.$store.isHeaderTransparent && (this.$store.isHeaderSolid = !1, 
          this.$store.isHeaderDarktheme = this.$store.isHeaderTD);
        },
        init() {
          const e = this.$refs.element;
          new IntersectionObserver((e => {
            let [t] = e;
            return this.pinned = t.intersectionRatio < 1;
          }), {
            threshold: [ 1 ]
          }).observe(e), this.$watch("$store.isHeaderTransparent", (() => {
            this.$store.isHeaderSolid = !this.$store.isHeaderTransparent, this.$store.isHeaderDarktheme = this.$store.isHeaderTD;
          })), this.$watch("$store.mq", (() => {
            this.$store.isHeaderSolid = !this.$store.isHeaderTransparent, this.$store.isHeaderDarktheme = this.$store.isHeaderTD;
          }));
        }
      }), Hr = () => ({
        isSearching: !1,
        isRoot: !0,
        index: null,
        handleSearchClick(e) {
          this.$refs.searchElement.value.replace(/\s/g, "").length || e.preventDefault(), 
          this.isSearching = !this.isSearching, this.$refs.searchElement.focus();
        },
        handleSearchOutsideClick() {
          this.isSearching = !1, this.$refs.searchElement.blur(), this.$refs.searchElement.value = "";
        },
        handleClick(e) {
          this.isRoot = !1, this.index = e;
        },
        handleBack() {
          this.isRoot = !0, setTimeout((() => this.index = null), 300);
        },
        reset() {
          this.$refs.rootScrollContainer.scrollTop = 0, this.isSearching = !1, this.isRoot = !0, 
          this.index = null;
        }
      }), Fr = function() {
        return {
          index: 0,
          length: arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          duration: 1e3 * (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6),
          interval: null,
          isPaused: !1,
          loop() {
            this.isPaused || (this.index = this.index === this.length - 1 ? 0 : this.index + 1);
          },
          handleClick(e) {
            this.index = e, clearInterval(this.interval), this.interval = setInterval(this.loop.bind(this), this.duration);
          },
          init() {
            this.interval = setInterval(this.loop.bind(this), this.duration);
          }
        };
      }, zr = function() {
        return {
          tab: 0,
          index: 0,
          subindex: null,
          length: arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          position: 0,
          fw: arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          items: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          progress: 0,
          progressDefault: null,
          slider: {
            "x-on:scroll.passive.debounce"() {
              this.calculateProgress();
            }
          },
          get sliderProgress() {
            return `--hrSlideWidth: ${this.progress}%;`;
          },
          prev() {
            let e = this.fw ? this.$refs.element?.querySelector("[data-slider]").querySelector("[data-id]").offsetWidth * this.items : this.$refs.element?.querySelector("[data-slider]").querySelector("[data-id]").offsetWidth;
            this.position = this.$refs.element?.querySelector("[data-slider]").scrollLeft, this.progress > this.progressDefault && this.$refs.element?.querySelector("[data-slider]").scrollTo({
              left: this.position - e,
              behavior: "smooth"
            });
          },
          next() {
            let e = this.fw ? this.$refs.element?.querySelector("[data-slider]").querySelector("[data-id]").offsetWidth * this.items : this.$refs.element?.querySelector("[data-slider]").querySelector("[data-id]").offsetWidth;
            this.position = this.$refs.element?.querySelector("[data-slider]").scrollLeft, this.progress < 100 && this.$refs.element?.querySelector("[data-slider]").scrollTo({
              left: this.position + e,
              behavior: "smooth"
            });
          },
          handleTabClick(e) {
            this.tab = e, this.calculateProgress(!0);
          },
          calculateProgress() {
            let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            this.$nextTick((() => {
              this.progress = 100 * Math.round((this.$refs.element?.querySelector("[data-slider]").scrollLeft + this.$refs.element?.querySelector("[data-slider]").offsetWidth) / this.$refs.element?.querySelector("[data-slider]").scrollWidth * 100) / 100, 
              e && !isNaN(this.progress) && (this.progressDefault = this.progress);
            }));
          },
          init() {
            this.calculateProgress(!0);
          }
        };
      }, Vr = function() {
        return {
          accessToken: !1,
          tokenURL: arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          limit: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 4,
          error(e) {
            sessionStorage.removeItem("InstagramToken"), console.warn("Error loading Instagram: " + e);
          },
          loadInstagram() {
            const e = this.$root.querySelector(".grid");
            new window.Instafeed({
              target: e,
              accessToken: this.accessToken,
              limit: this.limit,
              template: '<a href="{{link}}" class="group">\n      <div class="relative h-full w-full aspect-w-4 aspect-h-5 overflow-hidden after:absolute after:inset-0 after:bg-black-10 after:flex after:items-center after:justify-center after:text-white after:content-[\'@birdiefortescue\'] after:transiton-opacity after:duration-300 after:opacity-0 after:hover:opacity-100">\n        <img\n          src="{{image}}"\n          alt="{{caption}}"\n          class="w-full h-full object-cover object-center"\n        >\n      </div>\n    </a>',
              success: () => {
                this.$root.closest(".max-h-0").classList.remove("max-h-0");
              },
              error: e => {
                this.error(e);
              }
            }).run();
          },
          loadInstafeed() {
            try {
              var e = document.createElement("script");
              e.src = window.routes.asset_url + "instafeed.js", e.onload = e.onreadystatechange = this.loadInstagram.bind(this), 
              document.body.appendChild(e);
            } catch (e) {
              this.error(e);
            }
          },
          async load() {
            if (this.accessToken) this.loadInstafeed(); else try {
              let e = await fetch(this.tokenURL.replace(".js", ""));
              e = await e.json(), e.Token && (this.accessToken = e.Token, this.loadInstafeed());
            } catch (e) {
              this.error(e);
            }
          },
          init() {
            this.accessToken = sessionStorage.getItem("InstagramToken"), new IntersectionObserver(function(e, t) {
              this.load(), t.unobserve(this.$root);
            }.bind(this), {
              root: this.$root,
              rootMargin: "0px",
              threshold: 1
            }).observe(this.$root);
          }
        };
      }, Wr = () => ({
        isBtnIntersecting: !1,
        isFooterIntersecting: !1,
        isVisible: !1,
        init() {
          let e = document.getElementById("product-bag-btn"), t = document.getElementById("footer");
          if (e || t) {
            const r = new IntersectionObserver((t => {
              t.forEach((t => {
                if (window.scrollY > e.offsetTop) {
                  switch (t.target.id) {
                   case "product-bag-btn":
                    this.isBtnIntersecting = t.isIntersecting;
                    break;

                   case "footer":
                    this.isFooterIntersecting = t.isIntersecting;
                  }
                  this.isVisible = !this.isBtnIntersecting && !this.isFooterIntersecting;
                }
              }));
            }), {
              threshold: .95,
              rootMargin: "0px 0px 0px 0px"
            });
            e && r.observe(e), t && r.observe(document.getElementById("footer"));
          }
        }
      }), Ur = (e, t) => ({
        index: 0,
        autoplay: e || !1,
        timeout: t || 3e3,
        generateObserver(e) {
          return {
            observer: new IntersectionObserver(((e, t) => {
              let r = e.reduce(((e, t) => t.intersectionRatio > e.intersectionRatio ? t : e));
              r.intersectionRatio > 0 && (this.index = parseInt(r.target.dataset.id));
            }), {
              root: e,
              threshold: .5
            })
          };
        },
        init() {
          const {observer: e} = this.generateObserver(this.$refs.slider);
          let t = this.$refs.slider.children;
          for (let r = 0; r < t.length; r++) e.observe(t[r]);
          this.autoplay && (this.count = parseInt(this.$refs.slider.children[this.$refs.slider.children.length - 1].dataset.id), 
          setInterval((() => {
            let e = this.index + 1;
            e > this.count && (e = 0);
            const t = this.$refs.slider.querySelector(`[data-id='${e}']`);
            t && this.$refs.slider.scrollTo({
              left: t.offsetLeft,
              behavior: "smooth"
            });
          }), this.timeout));
        }
      }), Jr = () => ({
        active: !1,
        loading: !1,
        filterData: [],
        wrapper: {
          "x-bind:class"() {
            return this.$store.theme.filters ? "pointer-events-auto right-0" : "pointer-events-none delay-150 -right-full";
          }
        },
        renderPage(e) {
          let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          if (this.loading) return;
          e.includes("filter") && (document.getElementById("FilterReset").style.display = "block"), 
          this.loading = !0;
          const n = this.getSections();
          document.getElementById("ProductGrid") && (document.getElementById("ProductGrid").style.opacity = .25), 
          n.forEach((t => {
            const n = `${window.location.pathname}?section_id=${t.section}&${e}`, i = e => e.url === n;
            !t.facets && this.filterData.some(i) ? this.renderSectionFromCache(i, t, r) : this.renderSectionFromFetch(n, t, r);
          })), t && this.updateURLHash(e), this.loading = !1;
        },
        renderSectionFromFetch(e, t, r) {
          fetch(e).then((e => e.text())).then((n => {
            t.facets ? this.renderFacets(t, n) : (this.filterData = [ ...this.filterData, {
              html: n,
              url: e
            } ], this.renderProductGrid(n, t, r));
          }));
        },
        renderFacets(e, t) {
          e.facets.forEach((e => {
            let r = (new DOMParser).parseFromString(t, "text/html").querySelector(e).innerHTML;
            document.querySelectorAll(e).forEach((e => e.innerHTML = r));
          }));
        },
        renderSectionFromCache(e, t, r) {
          const n = this.filterData.find(e).html;
          this.renderProductGrid(n, t, r);
        },
        renderProductGrid(e, t, r) {
          const n = `#${t.id}`;
          let i = (new DOMParser).parseFromString(e, "text/html").querySelector(n);
          i && (i = i.innerHTML), r && t.appendable && i ? document.querySelector(n).insertAdjacentHTML("beforeend", i) : document.querySelector(n).innerHTML = i, 
          document.getElementById(t.id) && (document.getElementById(t.id).style.opacity = null), 
          document.getElementById("collection-grid") && window.scroll({
            top: document.getElementById("collection-grid").offsetTop - 75,
            left: 0
          });
        },
        getSectionID(e) {
          return !!document.getElementById(e) && document.getElementById(e).closest(".shopify-section").id.replace("shopify-section-", "");
        },
        getSections() {
          let e = [];
          return [ "ProductGrid", "Pagination" ].forEach((t => {
            let r = this.getSectionID(t);
            r && e.push({
              id: t,
              section: r,
              appendable: !1
            });
          })), e;
        },
        updateFromURL(e) {
          const t = new URL(e.target.href || e.target.closest("a").href).searchParams;
          this.renderPage(t.toString());
        },
        updateURLHash(e) {
          history.pushState({
            searchParams: e
          }, "", `${window.location.pathname}${e && "?".concat(e)}`);
        },
        onHistoryChange(e) {
          const t = e.state?.searchParams || "";
          this.renderPage(t);
        },
        previousPage(e) {
          e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), e && e.detail && e.detail.page && this.apply(!1, e, !0, !0);
        },
        nextPage(e) {
          e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), e && e.detail && e.detail.page && this.apply(!1, e, !0, !0);
        },
        handlePaginate(e) {
          e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), e && e.detail && e.detail.page && this.apply(!1, e, !0, !0);
        },
        apply() {
          let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments.length > 1 ? arguments[1] : void 0, r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
          const i = new FormData(this.$el.closest("form") || this.$root.querySelector("form") || this.$root);
          let s = document.getElementById("ProductSort");
          if (s) {
            const e = new FormData(s);
            for (var o of e.entries()) i.append(o[0], o[1]);
          }
          const a = new URLSearchParams(i);
          t && t.detail && t.detail.page && a.set("page", t.detail.page), this.renderPage(a.toString(), r, n), 
          e && document.dispatchEvent(new CustomEvent("collection:resetpage"));
        },
        sort(e) {
          const t = new FormData(this.$el.closest("form") || this.$root.querySelector("form") || this.$root), r = new FormData(document.getElementById("ProductSort"));
          for (var n of r.entries()) t.append(n[0], n[1]);
          const i = new URLSearchParams(t);
          i.set("sort_by", e.detail.event.target.value), this.renderPage(i.toString()), document.dispatchEvent(new CustomEvent("collection:resetpage"));
        },
        reset() {
          this.$root.querySelectorAll('input:not([name^="sort_by"])').forEach((e => e.checked = !1)), 
          document.dispatchEvent(new CustomEvent("filter:reset")), this.$nextTick((() => {
            this.apply(!0), document.getElementById("FilterReset").style.display = "none";
          }));
        },
        init() {
          window.addEventListener("popstate", this.onHistoryChange.bind(this)), document.addEventListener("collection:previouspaginate", this.previousPage.bind(this)), 
          document.addEventListener("collection:nextpaginate", this.nextPage.bind(this)), 
          document.addEventListener("collection:paginate", this.handlePaginate.bind(this)), 
          document.addEventListener("collection:sort", this.sort.bind(this)), window.location.search.includes("filter") && (document.getElementById("FilterReset").style.display = "block");
        }
      }), Kr = function() {
        return {
          minprice: arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          maxprice: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 7e3,
          min: arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
          max: arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1e3,
          minthumb: 0,
          maxthumb: 0,
          mintrigger() {
            this.minprice = Math.min(this.minprice, this.maxprice - (this.max - this.min) / 10), 
            this.minthumb = (this.minprice - this.min) / (this.max - this.min) * 100;
          },
          maxtrigger() {
            this.maxprice = Math.max(this.maxprice, this.minprice + (this.max - this.min) / 10), 
            this.maxthumb = 100 - (this.maxprice - this.min) / (this.max - this.min) * 100;
          },
          reset() {
            this.minprice = this.min, this.maxprice = this.max, this.mintrigger(), this.maxtrigger();
          },
          init() {
            let e = new URL(document.location).searchParams, t = e.get("filter.v.price.gte"), r = e.get("filter.v.price.lte");
            t && (this.minprice = Number(t)), r && (this.maxprice = Number(r)), this.mintrigger(), 
            this.maxtrigger(), document.addEventListener("filter:reset", this.reset.bind(this));
          }
        };
      }, Gr = function() {
        return {
          delay: arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 5,
          hide: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          bruteforce: arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          popState: window.Alpine.$persist(!1),
          popDate: window.Alpine.$persist(0),
          open() {
            this.$store.theme.popup = 1;
          },
          close() {
            this.$store.theme.popup = 0, this.popState = !0, this.popDate = Math.round(Date.now() / 1e3);
          },
          init() {
            let e = Math.round(Date.now() / 1e3), t = Math.floor((e - this.popDate) / 60 / 60 / 24);
            (!this.popState || t > this.hide || this.bruteforce) && setTimeout((() => {
              this.open();
            }), 1e3 * parseInt(this.delay));
          }
        };
      }, Zr = () => ({
        addToCartButton: window.languages.addToCart,
        product: {},
        variants: {},
        variant: null,
        idField: null,
        isBundleCompleted: !1,
        isBundleOutStock: !0,
        isBundleAdding: !1,
        updateButton() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "in", t = document.getElementsByClassName("product-bag-btns");
          for (let r = 0; r < t.length; r++) switch ("in" == e ? (t[r].disabled = !1, t[r].classList.add("bg-green", "hover:bg-[#6E805B]"), 
          t[r].classList.remove("bg-grey-30", "pointer-events-none")) : (t[r].disabled = !0, 
          t[r].classList.remove("bg-green", "hover:bg-[#6E805B]"), t[r].classList.add("bg-grey-30", "pointer-events-none")), 
          e) {
           case "in":
            this.variant ? this.variant.preorder ? t[r].textContent = window.languages.preorder + " — " + this.variant.preorder : this.variant.coming_soon ? t[r].textContent = window.languages.coming_soon + " — " + this.variant.coming_soon : t[r].textContent = window.languages.addToCart : t[r].textContent = window.languages.addToCart;
            break;

           case "out":
            t[r].textContent = window.languages.soldOut;
            break;

           case "select":
            t[r].textContent = window.languages.selectOptions;
          }
        },
        updateHash() {
          let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if ("URLSearchParams" in window) {
            var t = new URLSearchParams(window.location.search);
            e ? t.set("variant", e) : t.delete("variant"), history.replaceState(null, "", window.location.pathname + "?" + t.toString());
          }
        },
        updateNotifier(e) {
          this.$refs.notifier && (e ? this.$refs.notifier.classList.add("hidden") : this.$refs.notifier.classList.remove("hidden"));
        },
        updatePreorder() {
          this.$root.querySelectorAll('[name="properties[Preorder]').forEach((e => {
            this.variant && this.variant.preorder ? (e.value = this.variant.preorder, e.disabled = !1) : (e.value = null, 
            e.disabled = !0);
          }));
        },
        updateValues(e, t) {
          document.getElementById(e.target.dataset.valueId).innerHTML = e.target.value;
          try {
            this.$refs.productPrice.innerHTML = Shopify.formatMoney(t.price).replace(/[,.]{1}00$/, ""), 
            this.$refs.productComparePrice.style.display = "none", t.compare_at_price > t.price && (this.$refs.productComparePrice.style.display = "block", 
            this.$refs.productComparePrice.innerHTML = `${Shopify.formatMoney(t.compare_at_price).replace(/[,.]{1}00$/, "")}`);
          } catch (e) {
            this.$refs.ProductPriceWrapper.innerHTML = `\n        <span\n          x-ref="productComparePrice"\n          class="text-grey-50 line-through"\n          ${t.compare_at_price <= t.price && 'style="display:none"'}\n        >\n          ${t.compare_at_price > t.price && Shopify.formatMoney(t.compare_at_price).replace(/[,.]{1}00$/, "")}\n        </span>\n        <span x-ref="productPrice">\n          ${Shopify.formatMoney(t.price).replace(/[,.]{1}00$/, "")}\n        </span>\n      `;
          }
        },
        radioCallback(e) {
          this.$refs[e.target.dataset.optionIndex].value = e.target.value, this.selectCallback(e);
        },
        selectCallback(e) {
          let t = !1;
          if (1 == this.product.variants.length) t = this.variants[0] || this.product.variants[0]; else {
            let e = this.variants.filter((e => !(null !== e.option1 && e.option1 !== this.$refs.option1.value || null !== e.option2 && e.option2 !== this.$refs.option2.value || null !== e.option3 && e.option3 !== this.$refs.option3.value)));
            e.length && (t = e[0]);
          }
          if (t) this.variant = t, t.available ? (this.updateButton("in"), this.updateNotifier(!0)) : (this.updateButton("out"), 
          this.updateNotifier(!1)), void 0 !== e && this.updateValues(e, t), this.updateHash(t.id), 
          this.idField.value = t.id; else {
            let e = !this.$refs.option1 || "" == this.$refs.option1.value || !this.$refs.option2 || "" == this.$refs.option2.value;
            this.updateButton("select"), this.updateHash(), this.updateNotifier(e), this.idField.value = null;
          }
          this.updatePreorder();
        },
        addToCart() {
          if (parseInt(this.idField.value) > 0) {
            let e = document.getElementsByClassName("product-bag-btns");
            for (let t = 0; t < e.length; t++) e[t].disabled = !0;
            this.$store.theme.addToCart(this.$refs.form, (() => {
              for (let t = 0; t < e.length; t++) e[t].disabled = !1;
            }));
          }
        },
        handleChangeBundle() {
          this.isBundleCompleted = !Array.from(document.querySelectorAll("[data-multiple-options]")).find((e => "" === e.value));
        },
        handleSubmitBundle() {
          let e = new FormData(this.$refs.form);
          this.isBundleAdding = !0, fetch(routes.cart_add_url, {
            method: "POST",
            body: new URLSearchParams(e),
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((e => {
            200 === e.status ? window.dispatchEvent(new Event("added")) : console.log(`${e.description}`);
          })).catch((e => this.$refs.form.submit())).finally((() => {
            this.isBundleAdding = !1, window.dispatchEvent(new Event("bundle:added"));
          }));
        },
        init() {
          this.idField = this.$root.querySelector('[name="id"]'), this.product = JSON.parse(document.querySelector(`#ProductJSON-${this.$el.dataset.productId}`).textContent);
          const e = document.querySelector(`#VariantJSON-${this.$el.dataset.productId}`);
          this.variants = e ? JSON.parse(e.textContent) : this.product.variants, this.isBundleOutStock = document.querySelectorAll("[data-in-stock]").length < 1, 
          this.isBundleCompleted = document.querySelectorAll("[data-multiple-options] ").length < 1, 
          this.selectCallback();
        }
      }), Yr = (e, t, r) => ({
        freeShipping: {
          enabled: "" !== e,
          threshold: Number(e),
          pre: t,
          post: r
        },
        products: !1,
        relatedProduct: !1,
        loading: !1,
        tags: {},
        messages: [],
        wrapper: {
          "x-on:change.debounce.500ms"(e) {
            this.onChange(e);
          },
          "x-on:added.window"() {
            this.getCart(!0);
          }
        },
        freeShippingMessage: {
          "x-html"() {
            if (this.$data.freeShipping.enabled) return this.$store.theme.cartData.total_price >= this.$data.freeShipping.threshold ? this.$data.freeShipping.post : this.$data.freeShipping.pre.replace("[[amount]]", Shopify.formatMoney(this.$data.freeShipping.threshold - this.$store.theme.cartData.total_price));
          }
        },
        onChange(e) {
          this.updateQuantity(e.target.dataset.key, this.$el.querySelector(`[data-key="${e.target.dataset.key}"][name="quantity"]`).value);
        },
        updateCart(e) {
          this.$store.theme.cartData = e;
        },
        updateQuantity(e, t) {
          this.loading = !0;
          const r = JSON.stringify({
            id: e,
            quantity: t
          });
          fetch(routes.cart_change_url, {
            ...this.$store.theme.fetchConfig(),
            body: r
          }).then((e => e.json())).then((e => this.updateCart(e))).catch((e => console.error(e))).finally((() => this.loading = !1));
        },
        addItem(e) {
          this.loading = !0;
          const t = this.$store.theme.fetchConfig("javascript");
          t.headers["X-Requested-With"] = "XMLHttpRequest", t.body = JSON.stringify({
            items: [ {
              id: parseInt(e),
              quantity: 1
            } ]
          }), fetch(routes.cart_add_url, t).then((e => e.json())).then((e => {
            e.status && 200 !== e.status ? alert(`${e.description}`) : this.$dispatch("added");
          })).catch((e => console.error(e))).finally((() => this.loading = !1));
        },
        updateNote() {
          if (this.$refs.note) {
            const e = JSON.stringify({
              note: this.$refs.note.value
            });
            fetch(routes.cart_change_url, {
              ...this.$store.theme.fetchConfig(),
              body: e
            });
          }
        },
        async getTags(e) {
          return this.tags[e] ? this.tags[e] : fetch(`${routes.root_url}products/${e}.js`).then((e => e.json())).then((t => (this.tags[e] = t.tags, 
          t.tags)));
        },
        async getCart() {
          let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          fetch(routes.cart_url, this.$store.theme.fetchConfig()).then((e => e.json())).then((t => {
            this.updateCart(t), e && (this.$store.theme.cart = !0);
          })).catch((e => console.error(e)));
        },
        async getRelated() {
          fetch(arguments.length > 0 && void 0 !== arguments[0] && arguments[0]).then((e => e.json())).then((e => {
            const t = this.$store.theme.cartData.items.map((e => e.product_id));
            this.products = e.products.filter((e => e.available && !t.includes(e.id)));
          })).catch((e => console.warn(e)));
        },
        async init() {
          this.getCart(), this.messages = JSON.parse(this.$root.querySelector("script[data-messages]")?.textContent).messages, 
          this.$watch("$store.theme.cartData.items", (async e => {
            if (e.length > 0 && e[0].id !== this.relatedProduct && (this.getRelated(e[0].url.split("?")[0] + "?view=related"), 
            this.relatedProduct = e[0].id), e.length > 0) {
              const t = e.map((e => this.getTags(e.handle))), r = await Promise.all(t), n = new Set(r.flat());
              for (const e of this.messages) e.isActive = n.has(e.tag_1) && n.has(e.tag_2);
            }
          }));
        }
      }), Qr = e => ({
        product: !1,
        url: !1,
        loaded: !1,
        limit: e || 8,
        products: [],
        recents: [],
        recordRecent() {
          this.$store.theme.recentlyViewed.length && 0 !== this.$store.theme.recentlyViewed.filter((e => e.id === this.product.id)).length || (this.$store.theme.recentlyViewed.length || (this.$store.theme.recentlyViewed = []), 
          this.$store.theme.recentlyViewed.unshift({
            id: this.product.id,
            handle: this.product.handle
          }), this.$store.theme.recentlyViewed = this.$store.theme.recentlyViewed.slice(0, this.limit));
        },
        loadRecents() {
          if (this.$store.theme.recentlyViewed.length > 0) {
            let e = this.$store.theme.recentlyViewed.filter((e => e.id !== this.product.id));
            for (let t = 0; t < e.length; t++) fetch(`${window.routes.root_url}products/${e[t].handle}.js`).then((r => {
              if (r.status && 200 !== r.status) {
                let r = this.$store.theme.recentlyViewed.findIndex((r => r.id === e[t].id));
                return this.$store.theme.recentlyViewed.splice(r, 1), null;
              }
              return r.json();
            })).then((e => this.recents[t] = e)).catch((e => {
              console.warn(`Error loading recent products: ${e}`);
            }));
          } else this.recents = [];
        },
        handleIntersection(e, t) {
          e[0].isIntersecting && (t.unobserve(this.$root), this.url && fetch(this.url).then((e => e.json())).then((e => {
            this.products = e.products, this.loaded = !0, window.dispatchEvent(new Event("recommendations:set"));
          })).catch((e => console.warn(`Error loading Shopify recommendations: ${e}`))), this.loadRecents());
        },
        init() {
          this.product = JSON.parse(document.querySelector(`#ProductJSON-${this.$el.dataset.productId}`).textContent), 
          this.url = this.$root.dataset.url;
          new IntersectionObserver(this.handleIntersection.bind(this), {
            rootMargin: "0px 0px 200px 0px"
          }).observe(this.$root), this.$nextTick((() => this.recordRecent()));
        }
      }), Xr = e => ({
        page: e,
        previousPage() {
          this.page = this.page - 1, this.$el.dispatchEvent(new CustomEvent("collection:previouspaginate", {
            bubbles: !0,
            detail: {
              page: this.page
            }
          }));
        },
        nextPage() {
          this.page = this.page + 1, this.$el.dispatchEvent(new CustomEvent("collection:nextpaginate", {
            bubbles: !0,
            detail: {
              page: this.page
            }
          }));
        },
        handlePaginate(e) {
          this.page = e, this.$el.dispatchEvent(new CustomEvent("collection:paginate", {
            bubbles: !0,
            detail: {
              page: this.page
            }
          }));
        },
        reset() {
          this.page = 1;
        },
        init() {
          document.addEventListener("collection:resetpage", this.reset.bind(this));
        }
      }), en = () => ({
        handleChange(e) {
          this.$el.dispatchEvent(new CustomEvent("collection:sort", {
            bubbles: !0,
            detail: {
              event: e
            }
          }));
        }
      }), tn = () => ({
        form: !1,
        tab: !1,
        wrapper: {
          "x-bind:class"() {
            return this.$store.theme.search ? "pointer-events-auto right-0" : "pointer-events-none delay-150 -right-full";
          }
        },
        perform() {
          let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "search-drawer";
          (arguments.length > 0 && void 0 !== arguments[0] && arguments[0]).preventDefault(), 
          this.$store.theme.search = !0;
          const t = encodeURIComponent(this.form.q.value);
          if (!t) return;
          const r = this.form.querySelector('[name="type"]')?.dataset.resources || this.form.querySelector('[name="type"]')?.value || "product,page,article,collection,query";
          fetch(window.Shopify.routes.root + `search/suggest?q=${t}&resources[type]=${r}&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[limit_scope]=each&section_id=${e}`).then((e => e.text())).then((t => {
            const r = (new DOMParser).parseFromString(t, "text/html").querySelector(`#shopify-section-${e}`);
            [ '[x-ref="results"]', '[x-ref="button"]' ].forEach((e => {
              const t = this.form.querySelector(e);
              t && (t.innerHTML = r.querySelector(e).innerHTML);
            })), this.$refs.results.classList.remove("opacity-50");
          })).catch((e => {
            console.error(e), this.form.submit();
          }));
        },
        performDebounce() {
          let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "search-drawer";
          e.target.classList.contains("hidden") || (this.timeout && clearTimeout(this.timeout), 
          this.timeout = setTimeout((() => this.perform(e, t)), 200));
        },
        performImmediately() {
          let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "search-drawer";
          this.$refs.results.classList.add("opacity-50"), this.perform(e, t), this.form.q.blur();
        },
        init() {
          this.form = this.$root, this.form.querySelector('[name="q"]').addEventListener("input", (e => this.performDebounce(e))), 
          this.form.querySelector('[name="q"]').addEventListener("keypress", (e => "Enter" == e.key && this.form.submit())), 
          this.$watch("$store.theme.search", (e => e && this.form.querySelector('[name="q"]').focus()));
        }
      }), rn = () => ({
        countries: [],
        suggestedCountry: null,
        selectedCountry: null,
        dismissed: sessionStorage.getItem("localisation_dismissed") || !1,
        open() {
          this.$store.theme.scrollLock = !0, this.$nextTick((() => {
            this.$root.showModal();
          }));
        },
        close() {
          this.$store.theme.scrollLock = !1, this.$root.close(), sessionStorage.setItem("localisation_dismissed", !0);
        },
        updateLanguageSelector() {
          const e = this.countries.find((e => e.iso_code === this.selectedCountry)), t = this.$refs.languageSelector, r = t.value;
          e && (t.innerHTML = "", e.available_languages.forEach((e => {
            const n = document.createElement("option");
            n.value = e.iso_code, n.textContent = e.name, e.iso_code === r && (n.selected = !0), 
            t.appendChild(n);
          })), !t.value && e.available_languages.length > 0 && (t.value = e.available_languages[0].iso_code), 
          e.available_languages.length > 1 ? t.parentElement.classList.remove("hidden") : t.parentElement.classList.add("hidden"));
        },
        updateText(e) {
          e && (e.textContent = e.textContent.replaceAll("[[suggested_country]]", this.suggestedCountry.name), 
          e.textContent = e.textContent.replaceAll("[[suggested_country_code]]", this.suggestedCountry.iso_code));
        },
        init() {
          if (!this.dismissed) {
            try {
              this.countries = JSON.parse(this.$root.querySelector('script[type="application/json"]').textContent);
            } catch (e) {
              return void console.error("Could not parse country data", e);
            }
            fetch("/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true").then((e => e.json())).then((e => {
              if (e.detected_values) {
                const t = e.detected_values.country.handle.toUpperCase();
                this.suggestedCountry = this.countries.find((e => e.iso_code === t)), this.suggestedCountry && this.suggestedCountry.iso_code !== window.Shopify.country && (this.$root.querySelectorAll("[data-text]").forEach((e => this.updateText(e))), 
                this.selectedCountry = this.suggestedCountry.iso_code, this.updateLanguageSelector(), 
                this.open());
              }
            })).catch((e => console.error("Error fetching browsing context:", e))), this.$watch("selectedCountry", (() => {
              this.updateLanguageSelector();
            }));
          }
        }
      }), nn = () => ({
        errorEl: null,
        revision: "2024-07-15",
        init() {
          this.errorEl = this.$root.querySelector("[data-error]");
        },
        reset() {
          this.$root.querySelector("form").reset(), this.$root.querySelectorAll("[data-before]").forEach((e => e.classList.remove("hidden"))), 
          this.$root.querySelectorAll("[data-after]").forEach((e => e.classList.add("hidden"))), 
          this.errorEl.classList.add("hidden");
        },
        async submit(e) {
          const t = e.target, r = t.email.value.trim(), n = t.dataset.apiEndpoint, i = t.dataset.listId, s = t.dataset.accountId;
          if (!r) return;
          this.$root.querySelectorAll("[data-before]").forEach((e => e.classList.remove("hidden"))), 
          this.$root.querySelectorAll("[data-after]").forEach((e => e.classList.add("hidden")));
          const o = {
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: r
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: "list",
                    id: i
                  }
                }
              }
            }
          };
          t.classList.add("opacity-50", "cursor-wait"), this.errorEl.classList.add("hidden");
          const a = new URL(n);
          a.searchParams.append("company_id", s);
          try {
            (await fetch(a, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                revision: this.revision
              },
              body: JSON.stringify(o)
            })).ok ? (this.$root.querySelectorAll("[data-before]").forEach((e => e.classList.add("hidden"))), 
            this.$root.querySelectorAll("[data-after]").forEach((e => e.classList.remove("hidden")))) : this.errorEl.classList.remove("hidden");
          } catch (e) {
            console.warn("Klaviyo subscription error:", e), this.errorEl.classList.remove("hidden");
          } finally {
            t.classList.remove("opacity-50", "cursor-wait");
          }
        }
      });
      window.Alpine = Ar, Ar.plugin(Mr), Ar.data("Template", jr), Ar.data("Body", Rr), 
      Ar.data("Header", Br), Ar.data("Navigation", Hr), Ar.data("Hero", Fr), Ar.data("Slider", zr), 
      Ar.data("Instagram", Vr), Ar.data("ProductBar", Wr), Ar.data("ProductSlider", Ur), 
      Ar.data("Filters", Jr), Ar.data("RangeSlider", Kr), Ar.data("Popup", Gr), Ar.data("Product", Zr), 
      Ar.data("Cart", Yr), Ar.data("Recommendations", Qr), Ar.data("Pagination", Xr), 
      Ar.data("Sort", en), Ar.data("Search", tn), Ar.data("LocalisationPopup", rn), Ar.data("KlaviyoClientSubscribe", nn), 
      Ar.store("theme", Nr), Ar.store("mq", ""), Ar.store("isMenuOpen", !1), Ar.store("isHeaderSolid", !0), 
      Ar.store("isHeaderDarktheme", !0), Ar.store("isHeaderTransparent", !1), Ar.store("isHeaderTD", !1), 
      Ar.start();
    }
  }, t = {};
  function r(n) {
    var i = t[n];
    if (void 0 !== i) return i.exports;
    var s = t[n] = {
      exports: {}
    };
    return e[n](s, s.exports, r), s.exports;
  }
  r.r = function(e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r(537);
}();